/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useRef } from "react";
import { supabase } from "../supabaseClient";
import axios from "axios";
import toast from "react-hot-toast";
import { API_URL } from "../config";
import { useNavigate } from "react-router-dom";
import { getLookupPiyasalar, getLookupParaBirimleri, getLookupPeriyotlar } from "./apiCache";
import * as XLSX from "xlsx";

// ─── Renk Paleti ─────────────────────────────────────────────────────────────
const C = {
    bg:       "#0f172a",
    panel:    "#1e293b",
    border:   "#334155",
    text:     "#e2e8f0",
    muted:    "#94a3b8",
    accent:   "#3b82f6",
    bullish:  "#16a34a",
    bearish:  "#dc2626",
    warning:  "#f59e0b",
    gold:     "#eab308",
    purple:   "#7c3aed",
    teal:     "#0d9488",
};

// ─── Konfidans Kademesi Rengi ─────────────────────────────────────────────────
function kademeBilgi(kademe) {
    if (!kademe) return { renk: C.muted, bg: C.muted + "22", ikon: "○" };
    if (kademe.includes("Çok Yüksek")) return { renk: C.bullish,  bg: C.bullish  + "22", ikon: "⬆⬆" };
    if (kademe.includes("Yüksek"))     return { renk: "#22c55e",   bg: "#22c55e22",         ikon: "⬆" };
    if (kademe.includes("Orta"))       return { renk: C.gold,      bg: C.gold     + "22",   ikon: "→" };
    return                                    { renk: C.muted,     bg: C.muted    + "22",   ikon: "⬇" };
}

function konfidansRenk(v) {
    if (v >= 85) return C.bullish;
    if (v >= 70) return "#22c55e";
    if (v >= 50) return C.gold;
    return C.muted;
}

// ─── Token ──────────────────────────────────────────────────────────────────
async function getToken() {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) return null;
    if (session.expires_at * 1000 - Date.now() < 5 * 60 * 1000) {
        const { data } = await supabase.auth.refreshSession();
        return data.session?.access_token;
    }
    return session.access_token;
}

// ─── Hareketli Yükleme Çubuğu (Doğruluk kaydı sırasında) ─────────────────────
function HareketliBar() {
    const [offset, setOffset] = useState(0);
    useEffect(() => {
        const id = setInterval(() => setOffset(o => (o + 3) % 200), 20);
        return () => clearInterval(id);
    }, []);
    const pos = offset <= 100 ? offset - 100 : 200 - offset - 100;
    return (
        <div style={{ height: 8, background: C.bg, borderRadius: 4, overflow: "hidden",
            border: `1px solid ${C.border}`, marginBottom: 16, position: "relative" }}>
            <div style={{ position: "absolute", top: 0, height: "100%", width: "40%",
                left: `${50 + pos * 0.5}%`,
                background: "linear-gradient(90deg,transparent,#3b82f6,#06b6d4,#3b82f6,transparent)",
                borderRadius: 4 }} />
        </div>
    );
}

// ─── Skor Çubuğu ─────────────────────────────────────────────────────────────
function SkorBar({ deger, max = 100, renk }) {
    const pct = Math.min(Math.max((deger / max) * 100, 0), 100);
    return (
        <div style={{ flex: 1, height: 7, background: "#0f172a", borderRadius: 4, overflow: "hidden", border: `1px solid ${C.border}` }}>
            <div style={{ height: "100%", width: `${pct}%`, background: renk, borderRadius: 4, transition: "width 0.4s" }} />
        </div>
    );
}

// ─── Modül Etiketi ────────────────────────────────────────────────────────────
const MODUL_ETIKET = {
    fvg:           "FVG",
    msb:           "MSB",
    ote:           "OTE",
    obbb:          "OB/BB",
    likidite:      "Likidite",
    smt:           "SMT",
    pd:            "PD Zone",
    capa:          "Çapa",
    killzone:      "Killzone",
    divergence:    "Divergence",
    hacim_profili: "Hacim Profili",
    hacim_akisi:   "Hacim Akışı",
    inducement:    "IDM",
    karar_motoru:  "Karar Motoru",
    puanlama:      "Puanlama",
    coklu_tarama:  "Çoklu Tarama",
    dip:           "Dip Tarama",
    topdown:       "Topdown",
    islem:         "İşlem Planlama",
};
const MODUL_ETIKETI = (k) => MODUL_ETIKET[k] || k;

// ─── Aktif Modül Etiketleri ───────────────────────────────────────────────────
function ModulEtiketleri({ moduller, katkilar }) {
    if (!moduller || moduller.length === 0) return <span style={{ color: C.muted, fontSize: 12 }}>—</span>;
    // katkilar varsa güvenilirlik bilgisini al
    const katki_map = {};
    (katkilar || []).forEach(k => { katki_map[k.modul] = k; });
    return (
        <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
            {moduller.slice(0, 6).map((m, i) => {
                const renk  = m.yon === "ALIŞ" ? C.bullish : C.bearish;
                const katki = katki_map[m.modul];
                const dusuk = katki && katki.min_ornek_saglandi === false;
                return (
                    <span key={i} title={dusuk ? `⚠ Düşük güvenilirlik (${katki.ornek_sayisi} örnek < 20)` : ""}
                        style={{
                        fontSize: 10, padding: "2px 7px", borderRadius: 12,
                        background: renk + "22", color: renk, fontWeight: 600,
                        border: `1px solid ${dusuk ? C.warning : renk + "44"}`,
                        whiteSpace: "nowrap", opacity: dusuk ? 0.7 : 1,
                    }}>
                        {dusuk ? "⚠ " : ""}{MODUL_ETIKET[m.modul] || m.modul}
                    </span>
                );
            })}
            {moduller.length > 6 && (
                <span style={{ fontSize: 10, color: C.muted }}>+{moduller.length - 6}</span>
            )}
        </div>
    );
}

// ─── Bilgi Kartı Tooltip (sadece tarama/skorlama ile ilgili anahtarlar) ──────
const BILGI_ICERIK = {
    konfidans: {
        baslik: "Konfidans Skoru",
        aciklama: "ML modelinin o sembol için ürettiği başarı olasılığı (0-100). ≥85 Çok Yüksek, 70-85 Yüksek, 50-70 Orta, <50 Düşük. Piyasa rejimi ve haber duygusu bonusu ±5 puan etki eder.",
    },
    kademe: {
        baslik: "Kademe",
        aciklama: "Konfidans skoruna göre belirlenen güven seviyesi. Çok Yüksek (≥85): güçlü sinyal, pozisyon alınabilir. Yüksek (70-85): iyi sinyal, risk yönetimiyle değerlendirilebilir. Orta (50-70): zayıf sinyal, ek teyit bekle. Düşük (<50): sinyal güvenilir değil.",
    },
    confluence: {
        baslik: "Confluence (Çakışma)",
        aciklama: "Aynı anda sinyal veren modül sayısı. En az 3 modül eşzamanlı sinyal vermesi gerekir (Min Confluence kuralı). Daha fazla modül çakışması = daha güvenilir sinyal.",
    },
    aktif_moduller: {
        baslik: "Aktif Modüller",
        aciklama: "O anda sinyal üreten tarama modülleri. Her modülün rengi yönü gösterir: yeşil = alış, kırmızı = satış. Yön belirlenmesinde ML katsayıları, sektör RS ve haber skoru birlikte dikkate alınır.",
    },
    sektor_rs: {
        baslik: "Sektör RS (Relative Strength)",
        aciklama: "Sembolün ait olduğu sektörün XU100'e göre göreli gücü. 50 üzeri sektör endeksin üzerinde performans gösteriyor demektir. Yüksek RS, sektörel rüzgarın arkada olduğunu gösterir.",
    },
    haber: {
        baslik: "Haber Duygu Skoru",
        aciklama: "Son 7-30 günlük haberlerin duygu analizi sonucu (0-100). 50 üzeri pozitif, 50 altı negatif haber akışı. 'genel' etiketi: sembol özelinde haber bulunamadığında piyasa geneli haber skoru gösterilir.",
    },
    piyasa_rejim: {
        baslik: "Piyasa Rejim Puanı",
        aciklama: "ADX, EMA eğimi ve MSB/ZigZag analizine dayalı piyasa rejiminin sayısal temsili (0-100). 60+ Güçlü Boğa, 40-60 Yatay/Belirsiz, 40 altı Ayı rejimi. Güçlü ayı rejiminde alış sinyalleri %40 ceza alır.",
    },
    min_konfidans: {
        baslik: "Min Konfidans",
        aciklama: "Sonuç listesinde gösterilecek en düşük konfidans skoru eşiği. Bu eşiğin altında kalan semboller listeden gizlenir. Taramanın kendisini etkilemez, sadece görüntülenen sonuçları filtreler.",
    },
    min_confluence: {
        baslik: "Min Confluence",
        aciklama: "Sonuç listesinde gösterilecek en az aktif modül (confluence) sayısı. Modelin skor hesabında zaten aranan minimum 3 modül kuralı geçerlidir; buradaki filtre listeyi daha da daraltmak için kullanılır.",
    },
    model_cv: {
        baslik: "Model CV Skoru",
        aciklama: "Logistic Regression modelinin çapraz doğrulama (cross-validation) başarı oranı. Modelin, eğitim verisinde görmediği örnekler üzerinde ne kadar isabetli tahmin yaptığını gösterir. Yüksek CV skoru, modelin genelleme gücünün iyi olduğu anlamına gelir.",
    },
    ham_lr_skoru: {
        baslik: "Ham LR Skoru",
        aciklama: "Logistic Regression modelinin sigmoid çıktısı (0-1 arası olasılık). Bu değer 100 ile çarpılarak konfidans skoruna dönüştürülür. 0.5 = %50 konfidans. Min confluence sağlanmadıysa bu değer 0.7 ile çarpılarak cezalandırılır.",
    },
    yon_z_farki: {
        baslik: "Yön Z-Farkı",
        aciklama: "Alış yönlü modüllerin ağırlıklı toplam skoru (z_alış) eksi satış yönlü modüllerin skoru (z_satış). Pozitif = ML modeli alışı destekliyor, negatif = satışı destekliyor. Eşik: >0.05 ALIŞ, <-0.05 SATIŞ, ortada NÖTR.",
    },
    guvenilirlik: {
        baslik: "Modül Güvenilirliği",
        aciklama: "ML modelinin o modüle ne kadar güvendiğini gösterir (0-1). Minimum eğitim örneği (20) altında kalan modüllerin katsayısı kademeli olarak azaltılır. Az örnekle şişmiş ağırlıklar yanlış sinyal üretmesini engeller. 1.0 = tam güvenilir, 0.5 = 10 örnekle yarı güvenilir, 0.0 = hiç örnek yok.",
    },
};

function BilgiKarti({ karti, kapat }) {
    if (!karti || !BILGI_ICERIK[karti]) return null;
    const { baslik, aciklama } = BILGI_ICERIK[karti];
    return (
        <div style={{
            position: "fixed", inset: 0, zIndex: 999,
            display: "flex", alignItems: "center", justifyContent: "center",
            background: "rgba(0,0,0,0.6)",
        }} onClick={kapat}>
            <div style={{
                background: C.panel, border: `1px solid ${C.border}`, borderRadius: 14,
                padding: 28, maxWidth: 420, width: "90%", boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
            }} onClick={e => e.stopPropagation()}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
                    <span style={{ fontSize: 16, fontWeight: 700, color: C.text }}>ℹ️ {baslik}</span>
                    <button onClick={kapat} style={{ background: "none", border: "none", color: C.muted, fontSize: 20, cursor: "pointer" }}>✕</button>
                </div>
                <p style={{ fontSize: 14, color: C.muted, lineHeight: 1.7, margin: 0 }}>{aciklama}</p>
            </div>
        </div>
    );
}

function BilgiIkonu({ karti, setBilgiKarti }) {
    return (
        <span onClick={() => setBilgiKarti(karti)} title="Bilgi"
            style={{ marginLeft: 4, fontSize: 11, color: C.muted, cursor: "pointer",
                     borderRadius: "50%", border: `1px solid ${C.border}`,
                     padding: "0 4px", lineHeight: "16px", display: "inline-block",
                     userSelect: "none" }}>ℹ</span>
    );
}

// ─── Detay Paneli (Sağ Kenar) ────────────────────────────────────────────────
function KataloGostergesi({ deger, max = 10, renk }) {
    const pct = Math.min(Math.abs(deger) / max * 100, 100);
    return (
        <div style={{ display:"flex", alignItems:"center", gap:6, flex:1 }}>
            <div style={{ width:80, height:5, background:"#1e293b", borderRadius:3, overflow:"hidden" }}>
                <div style={{ height:"100%", width:`${pct}%`, background:renk, borderRadius:3 }} />
            </div>
            <span style={{ fontSize:11, color:renk, fontWeight:700, minWidth:42 }}>
                {deger > 0 ? "+" : ""}{deger?.toFixed(2)}
            </span>
        </div>
    );
}

function DetayPaneli({ satir, kapat, setBilgiKarti }) {
    if (!satir) return null;
    const kb  = kademeBilgi(satir.kademe);
    const kr  = konfidansRenk(satir.konfidans);
    const yon = satir.yon === "ALIŞ" ? C.bullish : satir.yon === "SATIŞ" ? C.bearish : C.muted;
    const katkilar = satir.modul_katkilar || [];

    const alisKatki  = katkilar.filter(k => k.yon_etkisi === "ALIŞ");
    const satisKatki = katkilar.filter(k => k.yon_etkisi === "SATIŞ");
    const maxKatki   = Math.max(...katkilar.map(k => Math.abs(k.katki_puan)), 1);

    const Bolum = ({ baslik }) => (
        <div style={{ fontSize:10, fontWeight:700, color:C.muted, letterSpacing:"0.07em",
            margin:"16px 0 8px", padding:"0 0 4px", borderBottom:`1px solid ${C.border}` }}>
            {baslik}
        </div>
    );

    const Satir = ({ etiket, deger, renk, karti, bold }) => (
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center",
            padding:"6px 0", borderBottom:`1px solid ${C.border}22` }}>
            <span style={{ fontSize:12, color:C.muted }}>
                {etiket}{karti && <BilgiIkonu karti={karti} setBilgiKarti={setBilgiKarti} />}
            </span>
            <span style={{ fontSize:12, fontWeight:bold?700:500, color:renk||C.text }}>{deger??'—'}</span>
        </div>
    );

    return (
        <>
            <div onClick={kapat} style={{ position:"fixed", inset:0, zIndex:200, background:"rgba(0,0,0,0.5)" }} />
            <div style={{
                position:"fixed", top:0, right:0, bottom:0, width:420, zIndex:201,
                background:C.panel, borderLeft:`2px solid ${C.border}`,
                overflowY:"auto", padding:"20px 20px 40px",
                boxShadow:"-6px 0 32px rgba(0,0,0,0.4)",
                fontFamily:"system-ui,sans-serif",
            }}>
                <style>{`@keyframes slideIn{from{transform:translateX(100%)}to{transform:translateX(0)}}
                .detay-panel{animation:slideIn 0.18s ease}`}</style>
                <div className="detay-panel">

                {/* Başlık */}
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:16 }}>
                    <div>
                        <div style={{ fontSize:24, fontWeight:800, color:C.accent, letterSpacing:"0.02em" }}>{satir.symbol}</div>
                        <div style={{ fontSize:12, color:C.muted, marginTop:2 }}>{satir.mod} · {satir.hesap_tarihi || "—"}</div>
                    </div>
                    <button onClick={kapat} style={{ background:"none", border:`1px solid ${C.border}`,
                        borderRadius:8, color:C.muted, fontSize:18, cursor:"pointer",
                        width:34, height:34, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>✕</button>
                </div>

                {/* Konfidans Kartı */}
                <div style={{ background:C.bg, borderRadius:12, padding:16, marginBottom:12,
                    border:`1px solid ${kr}55` }}>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-end", marginBottom:10 }}>
                        <div>
                            <div style={{ fontSize:10, color:C.muted, marginBottom:2 }}>
                                KONFİDANS SKORU<BilgiIkonu karti="konfidans" setBilgiKarti={setBilgiKarti} />
                            </div>
                            <div style={{ fontSize:38, fontWeight:900, color:kr, lineHeight:1 }}>
                                {satir.konfidans?.toFixed(1)}
                            </div>
                        </div>
                        <div style={{ textAlign:"right" }}>
                            <span style={{ padding:"4px 14px", borderRadius:20, fontSize:13, fontWeight:700,
                                background:kb.bg, color:kb.renk, display:"block", marginBottom:6 }}>
                                {kb.ikon} {satir.kademe}
                            </span>
                            <span style={{ fontSize:15, fontWeight:800, color:yon }}>
                                {satir.yon === "ALIŞ" ? "▲ ALIŞ" : satir.yon === "SATIŞ" ? "▼ SATIŞ" : "— NÖTR"}
                            </span>
                        </div>
                    </div>
                    <div style={{ height:8, background:C.border, borderRadius:4, overflow:"hidden" }}>
                        <div style={{ height:"100%", width:`${satir.konfidans}%`, background:kr, borderRadius:4, transition:"width 0.4s" }} />
                    </div>
                </div>

                {/* Confluence & Özet */}
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:8, marginBottom:12 }}>
                    {[
                        { label:"Confluence", deger:`${satir.aktif_modul_sayisi} modül`, renk:satir.min_confluence_karsilandi?C.bullish:C.bearish, karti:"confluence" },
                        { label:"Alış Modül", deger:`${satir.alis_modul_sayisi||0} ▲`, renk:C.bullish },
                        { label:"Satış Modül", deger:`${satir.satis_modul_sayisi||0} ▼`, renk:C.bearish },
                    ].map(({label,deger,renk,karti}) => (
                        <div key={label} style={{ background:C.bg, borderRadius:8, padding:"10px 10px",
                            border:`1px solid ${C.border}`, textAlign:"center" }}>
                            <div style={{ fontSize:9, color:C.muted, marginBottom:3 }}>
                                {label}{karti && <BilgiIkonu karti={karti} setBilgiKarti={setBilgiKarti} />}
                            </div>
                            <div style={{ fontSize:15, fontWeight:700, color:renk }}>{deger}</div>
                        </div>
                    ))}
                </div>

                {/* Güvenilirlik Uyarısı */}
                {satir.guvenilirlik_uyari && satir.dusuk_guvenilirlik?.length > 0 && (
                    <div style={{ background: C.warning + "15", border: `1px solid ${C.warning}44`,
                        borderRadius: 8, padding: "10px 12px", marginBottom: 12 }}>
                        <div style={{ fontSize: 11, color: C.warning, fontWeight: 700, marginBottom: 4 }}>
                            ⚠ Düşük Güvenilirlik Uyarısı
                        </div>
                        <div style={{ fontSize: 11, color: C.muted, lineHeight: 1.5 }}>
                            {satir.dusuk_guvenilirlik.map(mk => MODUL_ETIKETI(mk)).join(", ")} modülleri
                            için yeterli eğitim örneği yok (&lt;20). Bu modüllerin katsayısı
                            otomatik olarak azaltıldı. Daha fazla doğruluk analizi kaydı
                            birikince ağırlıklar güvenilir hale gelir.
                        </div>
                    </div>
                )}

                {/* Makro Göstergeler */}
                <Bolum baslik="MAKRO GÖSTERGELER" />
                <Satir etiket="Piyasa Rejim Puanı" karti="piyasa_rejim"
                    deger={satir.piyasa_rejim_puani?.toFixed(1)}
                    renk={satir.piyasa_rejim_puani>60?C.bullish:satir.piyasa_rejim_puani<40?C.bearish:C.gold} />
                <Satir etiket="Sektör RS" karti="sektor_rs"
                    deger={satir.sektorel_momentum!=null ? satir.sektorel_momentum.toFixed(1) : "—"}
                    renk={satir.sektorel_momentum>50?C.bullish:satir.sektorel_momentum<50?C.bearish:C.muted} />
                <Satir etiket="Haber Duygu" karti="haber"
                    deger={satir.haber_duygu_skoru!=null
                        ? `${satir.haber_duygu_skoru.toFixed(1)}${satir.haber_tip==="genel"?" (genel)":""}`
                        : "—"}
                    renk={satir.haber_duygu_skoru>50?C.bullish:satir.haber_duygu_skoru<50?C.bearish:C.muted} />

                {/* Bileşen Katkıları */}
                {katkilar.length > 0 && (<>
                    <Bolum baslik="KONFİDANS BİLEŞENLERİ — ML KATKILARI" />
                    <div style={{ background:C.bg, borderRadius:8, padding:10, marginBottom:10,
                        border:`1px solid ${C.border}`, fontSize:10, color:C.muted, lineHeight:1.7 }}>
                        <div style={{ color:C.text, fontWeight:600, marginBottom:4 }}>📐 Konfidans Nasıl Hesaplanır?</div>
                        <div>1. Her aktif modül için: <span style={{color:C.accent}}>katkı = ML_katsayısı × 100</span></div>
                        <div>2. Tüm katkılar toplanır → z skoru</div>
                        <div>3. <span style={{color:C.accent}}>Konfidans = sigmoid(z) × 100</span> = 1/(1+e⁻ᶻ) × 100</div>
                        {!satir.min_confluence_karsilandi && (
                            <div style={{color:C.warning, marginTop:2}}>4. ⚠ Min confluence sağlanmadı → ×0.7 ceza uygulandı</div>
                        )}
                        {(satir.sektorel_momentum != null || satir.haber_duygu_skoru != null) && (
                            <div style={{marginTop:2}}>4. Sektör RS ve haber skoru <span style={{color:C.gold}}>±5 puan bonus</span> olarak eklendi</div>
                        )}
                        <div style={{marginTop:4, color:C.text, fontWeight:600}}>
                            Sonuç: <span style={{color:konfidansRenk(satir.konfidans)}}>{satir.konfidans?.toFixed(1)}</span>
                        </div>
                    </div>
                    <div style={{ fontSize:10, color:C.muted, marginBottom:6 }}>
                        Aşağıdaki çubuklar her modülün katkı büyüklüğünü gösterir.
                        Yeşil çubuk = alışa katkı, kırmızı = satışa katkı.
                    </div>
                    {katkilar.map((k, i) => {
                        const renkK = k.katki_puan > 0 ? C.bullish : C.bearish;
                        const renkY = k.yon_etkisi === "ALIŞ" ? C.bullish : k.yon_etkisi === "SATIŞ" ? C.bearish : C.muted;
                        return (
                            <div key={i} style={{ padding:"7px 0", borderBottom:`1px solid ${C.border}22` }}>
                                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:4 }}>
                                    <span style={{ fontSize:12, color:C.text, fontWeight:600 }}>
                                        {MODUL_ETIKETI(k.modul)}
                                    </span>
                                    <div style={{ display:"flex", gap:8, alignItems:"center" }}>
                                        <span style={{ fontSize:10, padding:"2px 7px", borderRadius:10, fontWeight:700,
                                            background:renkY+"22", color:renkY }}>
                                            {k.yon === "ALIŞ" ? "▲" : k.yon === "SATIŞ" ? "▼" : "—"} {k.yon}
                                        </span>
                                        <span style={{ fontSize:11, color:C.muted, minWidth:44 }}>
                                            w={k.agirlik?.toFixed(3)}
                                        </span>
                                    </div>
                                </div>
                                <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                                    <span style={{ fontSize:10, color:C.muted, minWidth:80 }}>Konfidans katkısı</span>
                                    <KataloGostergesi deger={k.katki_puan} max={maxKatki*1.2} renk={renkK} />
                                </div>
                                {k.min_ornek_saglandi === false && (
                                    <div style={{ fontSize:10, color:C.warning, marginTop:3,
                                        display:"flex", alignItems:"center", gap:4 }}>
                                        ⚠ {k.ornek_sayisi ?? "?"} örnek &lt; 20 min · katsayı ×{k.guvenilirlik?.toFixed(2) ?? "?"} ölçeklendi
                                    </div>
                                )}
                                {k.yon !== k.yon_etkisi && (
                                    <div style={{ fontSize:10, color:C.warning, marginTop:3 }}>
                                        ⚠ Negatif ağırlık: sinyal yönünün tersine etki ediyor
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </>)}

                {/* Yön Analizi */}
                <Bolum baslik="YÖN BELİRLEME ANALİZİ" />
                <div style={{ fontSize:10, color:C.muted, marginBottom:8, lineHeight:1.5 }}>
                    ML katsayıları, sektör RS ve haber skoru birlikte değerlendirilerek yön belirlenir.
                </div>
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:8, marginBottom:12 }}>
                    <div style={{ background:C.bullish+"11", border:`1px solid ${C.bullish}33`, borderRadius:8, padding:12 }}>
                        <div style={{ fontSize:10, color:C.bullish, fontWeight:700, marginBottom:6 }}>ALIŞ YÖNÜ ETKİSİ</div>
                        {alisKatki.length === 0
                            ? <div style={{ fontSize:11, color:C.muted }}>Modül yok</div>
                            : alisKatki.map((k,i) => (
                                <div key={i} style={{ fontSize:11, color:C.text, display:"flex", justifyContent:"space-between", marginBottom:2 }}>
                                    <span>{MODUL_ETIKETI(k.modul)}</span>
                                    <span style={{ color:C.bullish, fontWeight:600 }}>+{Math.abs(k.katki_puan).toFixed(2)}</span>
                                </div>
                            ))
                        }
                    </div>
                    <div style={{ background:C.bearish+"11", border:`1px solid ${C.bearish}33`, borderRadius:8, padding:12 }}>
                        <div style={{ fontSize:10, color:C.bearish, fontWeight:700, marginBottom:6 }}>SATIŞ YÖNÜ ETKİSİ</div>
                        {satisKatki.length === 0
                            ? <div style={{ fontSize:11, color:C.muted }}>Modül yok</div>
                            : satisKatki.map((k,i) => (
                                <div key={i} style={{ fontSize:11, color:C.text, display:"flex", justifyContent:"space-between", marginBottom:2 }}>
                                    <span>{MODUL_ETIKETI(k.modul)}</span>
                                    <span style={{ color:C.bearish, fontWeight:600 }}>-{Math.abs(k.katki_puan).toFixed(2)}</span>
                                </div>
                            ))
                        }
                    </div>
                </div>

                {/* ML Skor */}
                <Bolum baslik="ML MODEL ÇIKTILAR" />
                <Satir etiket="Ham LR Skoru (prob)" karti="ham_lr_skoru" deger={satir.ham_skor!=null?satir.ham_skor.toFixed(4):"—"} />
                <Satir etiket="Yön Z-Farkı (alış−satış)" karti="yon_z_farki" 
                    deger={satir.yon_skoru!=null ? (satir.yon_skoru > 0 ? `+${satir.yon_skoru.toFixed(4)}` : satir.yon_skoru.toFixed(4)) : "—"}
                    renk={satir.yon_skoru > 0 ? C.bullish : satir.yon_skoru < 0 ? C.bearish : C.muted} />
                <Satir etiket="Min Confluence Sağlandı" karti="confluence"
                    deger={satir.min_confluence_karsilandi ? "✓ Evet" : "✗ Hayır"}
                    renk={satir.min_confluence_karsilandi ? C.bullish : C.bearish} bold />
                </div>
            </div>
        </>
    );
}

// ─── Tarama İlerleme Paneli ──────────────────────────────────────────────────
function TaramaIlerlemePaneli({ durum, mod }) {
    const gecen      = durum.gecen      || 0;
    const ilerleme   = durum.ilerleme   || 0;
    const tamamlanan = durum.tamamlanan || 0;
    const toplam     = durum.toplam     || 0;
    const bulunan    = durum.bulunan    || 0;
    const aktif      = durum.aktif      || "";

    let tahminiKalan = null;
    if (tamamlanan > 0 && gecen > 0 && toplam > 0) {
        const snPerSembol = gecen / tamamlanan;
        tahminiKalan = Math.round(snPerSembol * (toplam - tamamlanan));
    }

    const formatSure = (sn) => {
        if (sn == null || sn < 0) return "—";
        const h = Math.floor(sn / 3600);
        const m = Math.floor((sn % 3600) / 60);
        const s = sn % 60;
        if (h > 0) return `${String(h).padStart(2,"0")}:${String(m).padStart(2,"0")}:${String(s).padStart(2,"0")}`;
        return `${String(m).padStart(2,"0")}:${String(s).padStart(2,"0")}`;
    };

    return (
        <div style={{
            marginBottom: 16, background: C.panel,
            border: `2px solid ${C.accent}44`, borderRadius: 12, padding: 20,
            boxShadow: `0 0 20px ${C.accent}18`,
        }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14 }}>
                <span style={{ fontSize: 20 }}>🔍</span>
                <span style={{ fontSize: 15, fontWeight: 700, color: C.text }}>
                    Birleşik Skor Tarama — {mod}
                </span>
                <span style={{ marginLeft: "auto", fontSize: 22, fontWeight: 800, color: C.accent }}>
                    %{ilerleme}
                </span>
            </div>

            <div style={{ height: 10, background: C.bg, borderRadius: 6, overflow: "hidden", marginBottom: 10, border: `1px solid ${C.border}` }}>
                <div style={{
                    height: "100%", width: `${ilerleme}%`,
                    background: `linear-gradient(90deg, ${C.accent}, #06b6d4)`,
                    borderRadius: 6, transition: "width 0.5s ease",
                }} />
            </div>

            <div style={{ fontSize: 13, color: C.muted, marginBottom: 14, minHeight: 18 }}>
                {aktif
                    ? <span>Skorlanan: <strong style={{ color: C.text }}>{aktif}</strong></span>
                    : <span>Başlatılıyor...</span>
                }
            </div>

            <div style={{ display: "flex", gap: 20, flexWrap: "wrap" }}>
                <div>
                    <div style={{ fontSize: 10, color: C.muted, marginBottom: 2 }}>TAMAMLANAN</div>
                    <div style={{ fontSize: 16, fontWeight: 700, color: C.accent }}>
                        {tamamlanan.toLocaleString("tr-TR")} / {toplam.toLocaleString("tr-TR")}
                    </div>
                </div>
                <div>
                    <div style={{ fontSize: 10, color: C.muted, marginBottom: 2 }}>BULUNAN</div>
                    <div style={{ fontSize: 16, fontWeight: 700, color: C.bullish }}>
                        {bulunan.toLocaleString("tr-TR")}
                    </div>
                </div>
                <div>
                    <div style={{ fontSize: 10, color: C.muted, marginBottom: 2 }}>GEÇEN SÜRE</div>
                    <div style={{ fontSize: 16, fontWeight: 700, color: C.teal }}>{formatSure(gecen)}</div>
                </div>
                <div>
                    <div style={{ fontSize: 10, color: C.muted, marginBottom: 2 }}>TAHMİNİ KALAN</div>
                    <div style={{ fontSize: 16, fontWeight: 700, color: C.gold }}>
                        {tahminiKalan != null ? formatSure(tahminiKalan) : (tamamlanan === 0 ? "Hesaplanıyor..." : "—")}
                    </div>
                </div>
            </div>
        </div>
    );
}

// ─── Çoklu Taramaya Gönder — Modül Listesi ───────────────────────────────────
const COKLU_MODULLER = [
    { label: "📊 Dip Tarama",           value: "Dip Tarama",                     pasif: false },
    { label: "🌊 Likidite Tarama",       value: "Likidite Tarama",                pasif: false },
    { label: "📈 FVG Tarama",            value: "FVG Tarama",                     pasif: false },
    { label: "⚓ Çapa Noktası Tarama",   value: "Çapa Noktası Tarama",            pasif: false },
    { label: "📐 MSB Tarama",            value: "MSB Tarama",                     pasif: false },
    { label: "🎯 OTE Tarama",            value: "OTE Tarama",                     pasif: false },
    { label: "🧱 OB/BB Tarama",          value: "OB & BB Tarama",                 pasif: false },
    { label: "🎣 IDM Tarama",            value: "IDM Tarama",                     pasif: false },
    { label: "⚖️ P/D Zone Tarama",       value: "P/D Zone Tarama",               pasif: false },
    { label: "🔀 SMT Tarama",            value: "Korelasyonel Uyumsuzluk Tarama", pasif: false },
    { label: "⏰ Killzone Tarama",        value: "Killzone Tarama",               pasif: false },
    { label: "🌿 Topdown Cascade",        value: "Topdown Cascade",               pasif: false },
    { label: "📊 Hacim Profili Tarama",   value: "Hacim Profili Tarama",          pasif: false },
    { label: "🌊 Hacim Akışı Tarama",     value: "Hacim Akışı Tarama",            pasif: false },
    { label: "📉 Divergence Tarama",      value: "Divergence Tarama",             pasif: false },
];

const _PERIYOT_OPTS = ["1 Gün", "1 Hafta", "1 Ay", "3 Aylık", "6 Aylık", "Yıllık"];
const _KZ_LISTESI   = [
    "Asya KZ (03:00-09:00)", "Londra Açılış (10:00-12:00)", "New York Açılış (15:00-17:00)",
    "Londra Kapanış (18:00-20:00)", "BIST Açılış (10:00-11:00)",
    "BIST Öğle Dönüşü (13:00-14:00)", "BIST Kapanış Öncesi (17:00-18:00)",
];

function defaultCokluFiltreler(modul, piyasa) {
    switch (modul) {
        case "Dip Tarama":       return { tarama_periyot: "Aylık", tolerans: 1 };
        case "Likidite Tarama":  return { sweep_tipler: { "Boğa Sweep": true, "Ayı Sweep": false }, tarama_periyot: "1 Gün", lookback: 20, wick_oran: 50 };
        case "FVG Tarama":       return { fvg_tipler: { "Boğa FVG": true, "Ayı FVG": false, "iFVG": false }, bpr_kontrol: "Hayır", tarama_periyot: "1 Gün", mum_sayisi: 100 };
        case "Çapa Noktası Tarama": return { fvg_tipler: { "Boğa FVG": true, "Ayı FVG": false }, tolerans: 30 };
        case "MSB Tarama":       return { msb_tipler: { "Boğa MSB": true, "Ayı MSB": false }, tarama_periyot: "1 Ay", swing_pencere: 3 };
        case "OTE Tarama":       return { ote_tipler: { "Boğa OTE": true, "Ayı OTE": false }, tarama_periyot: "1 Hafta", swing_pencere: 3, mum_sayisi: 100 };
        case "OB & BB Tarama":   return { obbb_tipler: { "Boğa OB": true, "Ayı OB": false, "Boğa BB": false, "Ayı BB": false }, tarama_periyot: "1 Gün", mum_sayisi: 200, govde_oran: 60, sadece_taze: true };
        case "IDM Tarama":       return { idm_tipler: { "Boğa IDM": true, "Ayı IDM": false }, tarama_periyot: "1 Gün", mum_sayisi: 200 };
        case "P/D Zone Tarama":  return { bolge_filtre: { "Discount": true, "Equilibrium": false, "Premium": false }, tarama_periyot: "1 Gün", range_window: 20, mum_sayisi: 200 };
        case "Korelasyonel Uyumsuzluk Tarama": return { smt_tipler: { "Boğa SMT": true, "Ayı SMT": false }, tarama_periyot: "1 Gün", referans_varlik: piyasa === "BIST" ? "XU100 (BIST100)" : "BTC", swing_pencere: 3, kor_pencere: 50, min_korelasyon: 70, mum_sayisi: 200 };
        case "Killzone Tarama":  return { killzoneler: { "BIST Açılış (10:00-11:00)": true }, yapi_tipleri: { "FVG": true, "MSB": false, "Sweep": false }, geri_bak_gun: 5 };
        case "Topdown Cascade":   return { topdown_mod: piyasa };
        case "Hacim Profili Tarama": return { tarama_periyot: "1 Gün", sinyal_filtre: [], min_skor: 0, mum_sayisi: 300 };
        case "Hacim Akışı Tarama": return { lookback: 20, min_spike: 1.5, sinyal_filtre: {"📈 Güçlü Alım":true,"🔶 Orta Alım":true,"⬇️ Zayıf Alım":false,"📉 Güçlü Satım":true,"🔶 Orta Satım":true,"⬆️ Zayıf Satım":false,"⚖️ Belirsiz":false} };
        case "Divergence Tarama": return { tarama_periyot: "1 Gün", pivot_modu: "fractal", osilatorler: {"RSI":true,"MACD Histogram":true,"Stokastik RSI":true,"OBV":false}, divergence_tipleri: {"Regular Bullish":true,"Regular Bearish":true,"Hidden Bullish":false,"Hidden Bearish":false}, swing_pencere:5, zigzag_esik:1, n_son_pivot:2, min_pivot_mesafe:3, min_hareket_atr:0, rsi_periyot:14, macd_fast:12, macd_slow:26, macd_signal:9, stoch_rsi_periyot:14, stoch_periyot:14, stoch_k:3, stoch_d:3, ayarlar_acik:false };
        default: return {};
    }
}

const popupStyles = {
    overlay:   { position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 },
    modal:     { background: "#1e293b", border: "1px solid #334155", borderRadius: "14px", padding: "2rem", width: "480px", maxWidth: "95vw", boxShadow: "0 12px 48px rgba(0,0,0,0.5)", color: "#e2e8f0" },
    baslik:    { fontSize: "18px", fontWeight: "700", color: "#e2e8f0", marginBottom: "0.75rem" },
    btnVazgec: { padding: "8px 18px", borderRadius: "8px", border: "1px solid #334155", background: "transparent", cursor: "pointer", fontSize: "13px", color: "#94a3b8" },
    btnPrimary:{ padding: "8px 20px", borderRadius: "8px", border: "none", background: "linear-gradient(135deg,#1d4ed8,#3b82f6)", color: "white", cursor: "pointer", fontSize: "13px", fontWeight: "600" },
};

function CokluTaramaGonderPopup({ piyasa, paraBirimi, secilenSayisi, secilenModul, filtre, periyotlar, onModulSec, onFiltreDegis, onIptal, onBaslat }) {
    const periyotOpts = periyotlar && periyotlar.length > 0 ? periyotlar : _PERIYOT_OPTS;
    const set = (key, val) => onFiltreDegis({ ...filtre, [key]: val });
    const ck  = (grup, key) => onFiltreDegis({ ...filtre, [grup]: { ...filtre[grup], [key]: !filtre[grup][key] } });

    const CheckGrup = ({ alan, etiket }) => (
        <div style={{ marginBottom: "10px" }}>
            <div style={{ fontSize: "12px", fontWeight: "600", color: "#93c5fd", marginBottom: "6px" }}>{etiket}</div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                {Object.keys(filtre[alan] || {}).map(k => (
                    <label key={k} style={{ display: "flex", alignItems: "center", gap: "4px", fontSize: "12px", cursor: "pointer" }}>
                        <input type="checkbox" checked={!!filtre[alan][k]} onChange={() => ck(alan, k)} />{k}
                    </label>
                ))}
            </div>
        </div>
    );

    const Sel = ({ alan, etiket, opts, labelFn }) => (
        <div style={{ marginBottom: "10px" }}>
            <div style={{ fontSize: "12px", fontWeight: "600", color: "#93c5fd", marginBottom: "6px" }}>{etiket}</div>
            <select value={filtre[alan]} onChange={e => set(alan, isNaN(e.target.value) ? e.target.value : Number(e.target.value))}
                style={{ padding: "6px 10px", borderRadius: "7px", border: "1px solid #334155", background: "#0f172a", color: "#e2e8f0", fontSize: "13px", width: "100%" }}>
                {opts.map(o => <option key={o} value={o}>{labelFn ? labelFn(o) : o}</option>)}
            </select>
        </div>
    );

    const renderFiltreler = () => {
        if (!filtre) return null;
        switch (secilenModul) {
            case "Dip Tarama":       return (<><Sel alan="tarama_periyot" etiket="Periyot" opts={periyotOpts} /><Sel alan="tolerans" etiket="Tolerans" opts={[1,3,5]} labelFn={v=>`%${v}`} /></>);
            case "Likidite Tarama":  return (<><CheckGrup alan="sweep_tipler" etiket="Sweep Tipi" /><Sel alan="tarama_periyot" etiket="Periyot" opts={periyotOpts} /><Sel alan="lookback" etiket="Lookback" opts={[10,20,50,100]} labelFn={v=>`${v} Mum`} /><Sel alan="wick_oran" etiket="Min Fitil" opts={[30,40,50,60,70]} labelFn={v=>`%${v}`} /></>);
            case "FVG Tarama":       return (<><CheckGrup alan="fvg_tipler" etiket="FVG Tipi" /><Sel alan="bpr_kontrol" etiket="BPR Kontrol" opts={["Evet","Hayır"]} /><Sel alan="tarama_periyot" etiket="Tarama Periyodu" opts={periyotOpts} /><Sel alan="mum_sayisi" etiket="Mum Sayısı" opts={[25,50,100,150,200,250,300,350,400,500,600,700]} /></>);
            case "Çapa Noktası Tarama": return (<><CheckGrup alan="fvg_tipler" etiket="FVG Tipi" /><Sel alan="tolerans" etiket="Tolerans" opts={[30,50,70,80,90,100]} labelFn={v=>`%${v}`} /></>);
            case "MSB Tarama":       return (<><CheckGrup alan="msb_tipler" etiket="MSB Tipi" /><Sel alan="tarama_periyot" etiket="Periyot" opts={periyotOpts} /><Sel alan="swing_pencere" etiket="Swing Penceresi" opts={[2,3,4,5,6,7,8]} labelFn={v=>`${v} Mum`} /></>);
            case "OTE Tarama":       return (<><CheckGrup alan="ote_tipler" etiket="OTE Tipi" /><Sel alan="tarama_periyot" etiket="Tarama Periyodu" opts={periyotOpts} /><Sel alan="swing_pencere" etiket="Swing Penceresi" opts={[2,3,4,5,6,7,8]} labelFn={v=>`${v} Mum`} /><Sel alan="mum_sayisi" etiket="Mum Sayısı" opts={[50,100,150,200,300]} /></>);
            case "OB & BB Tarama":   return (<><CheckGrup alan="obbb_tipler" etiket="OB/BB Tipi" /><Sel alan="tarama_periyot" etiket="Periyot" opts={periyotOpts} /><Sel alan="mum_sayisi" etiket="Mum Sayısı" opts={[100,200,300,500]} /><Sel alan="govde_oran" etiket="Min Gövde" opts={[40,50,60,70]} labelFn={v=>`%${v}`} /><div style={{marginBottom:"10px"}}><label style={{display:"flex",alignItems:"center",gap:"6px",fontSize:"12px",cursor:"pointer"}}><input type="checkbox" checked={filtre.sadece_taze} onChange={e=>set("sadece_taze",e.target.checked)} />Sadece Taze</label></div></>);
            case "IDM Tarama":       return (<><CheckGrup alan="idm_tipler" etiket="IDM Tipi" /><Sel alan="tarama_periyot" etiket="Periyot" opts={periyotOpts} /><Sel alan="mum_sayisi" etiket="Mum Sayısı" opts={[100,200,300,500]} /></>);
            case "P/D Zone Tarama":  return (<><CheckGrup alan="bolge_filtre" etiket="Bölge" /><Sel alan="tarama_periyot" etiket="Periyot" opts={periyotOpts} /><Sel alan="range_window" etiket="Range Penceresi" opts={[10,20,50,100]} labelFn={v=>`${v} Mum`} /><Sel alan="mum_sayisi" etiket="Mum Sayısı" opts={[100,200,300,500]} /></>);
            case "Korelasyonel Uyumsuzluk Tarama": return (<><CheckGrup alan="smt_tipler" etiket="SMT Tipi" /><Sel alan="tarama_periyot" etiket="Periyot" opts={periyotOpts} /><div style={{marginBottom:"10px"}}><div style={{fontSize:"12px",fontWeight:"600",color:"#93c5fd",marginBottom:"6px"}}>Referans Varlık</div><select value={filtre.referans_varlik} onChange={e=>set("referans_varlik",e.target.value)} style={{padding:"6px 10px",borderRadius:"7px",border:"1px solid #334155",background:"#0f172a",color:"#e2e8f0",fontSize:"13px",width:"100%"}}>{(piyasa==="BIST"?["XU100 (BIST100)","XU030 (BIST30)"]:["BTC","ETH","BNB"]).map(v=><option key={v}>{v}</option>)}</select></div><Sel alan="swing_pencere" etiket="Swing Penceresi" opts={[2,3,5]} labelFn={v=>`${v} Mum`} /><Sel alan="min_korelasyon" etiket="Min Korelasyon" opts={[50,60,70,80,90]} labelFn={v=>`%${v}`} /><Sel alan="mum_sayisi" etiket="Mum Sayısı" opts={[100,200,300]} /></>);
            case "Killzone Tarama":  return (<><div style={{marginBottom:"10px"}}><div style={{fontSize:"12px",fontWeight:"600",color:"#93c5fd",marginBottom:"6px"}}>Killzone</div><div style={{display:"flex",flexWrap:"wrap",gap:"8px"}}>{_KZ_LISTESI.filter(k=>piyasa==="BIST"||!k.includes("BIST")).map(k=><label key={k} style={{display:"flex",alignItems:"center",gap:"4px",fontSize:"12px",cursor:"pointer"}}><input type="checkbox" checked={!!filtre.killzoneler[k]} onChange={()=>ck("killzoneler",k)} />{k.split("(")[0].trim()}</label>)}</div></div><div style={{marginBottom:"10px"}}><div style={{fontSize:"12px",fontWeight:"600",color:"#93c5fd",marginBottom:"6px"}}>Yapı Tipi</div><div style={{display:"flex",gap:"12px"}}>{["FVG","MSB","Sweep"].map(k=><label key={k} style={{display:"flex",alignItems:"center",gap:"4px",fontSize:"12px",cursor:"pointer"}}><input type="checkbox" checked={!!filtre.yapi_tipleri[k]} onChange={()=>ck("yapi_tipleri",k)} />{k}</label>)}</div></div><Sel alan="geri_bak_gun" etiket="Geriye Bakış" opts={[1,3,5,10]} labelFn={v=>`Son ${v} Gün`} /></>);
            case "Topdown Cascade": return (<div style={{fontSize:"13px",color:"#94a3b8",padding:"8px 0"}}>{piyasa} — EMA200 + 4H Sweep taraması. Ek kriter seçimi gerekmez.</div>);
            case "Hacim Profili Tarama": {
                const HP_SF = ["POC Yakını","Discount","Premium","HVN Yakın","LVN İçi"];
                const hpSF = filtre.sinyal_filtre || [];
                const toggleHpSF = v => { const sf = Array.isArray(hpSF)?hpSF:[]; set("sinyal_filtre", sf.includes(v)?sf.filter(x=>x!==v):[...sf,v]); };
                return (<>
                    <Sel alan="tarama_periyot" etiket="Periyot" opts={periyotOpts} />
                    <div style={{marginBottom:"10px"}}><div style={{fontSize:"12px",fontWeight:"600",color:"#93c5fd",marginBottom:"6px"}}>Sinyal Filtresi</div>
                        <div style={{display:"flex",flexWrap:"wrap",gap:"6px"}}>{HP_SF.map(v=>{const aktif=Array.isArray(hpSF)&&hpSF.includes(v);return(<button key={v} type="button" onClick={()=>toggleHpSF(v)} style={{padding:"3px 10px",borderRadius:20,fontSize:11,cursor:"pointer",fontWeight:aktif?600:400,border:`1px solid ${aktif?"#3b82f6":"#334155"}`,background:aktif?"#3b82f622":"transparent",color:aktif?"#3b82f6":"#94a3b8"}}>{v}</button>);})}</div>
                    </div>
                    <Sel alan="min_skor" etiket="Min Skor" opts={[0,2,3,4,5,6,7]} labelFn={v=>v===0?"Tümü":`≥${v}`} />
                    <Sel alan="mum_sayisi" etiket="Mum Sayısı" opts={[100,200,300,500]} />
                </>);
            }
            case "Hacim Akışı Tarama": {
                const HA_RENK_MAP = {"📈 Güçlü Alım":"#16a34a","🔶 Orta Alım":"#84cc16","⬇️ Zayıf Alım":"#a3e635","📉 Güçlü Satım":"#dc2626","🔶 Orta Satım":"#f97316","⬆️ Zayıf Satım":"#fca5a5","⚖️ Belirsiz":"#9ca3af"};
                const haSF = (typeof filtre.sinyal_filtre==="object"&&!Array.isArray(filtre.sinyal_filtre)) ? filtre.sinyal_filtre : {};
                const toggleHA = s => set("sinyal_filtre",{...haSF,[s]:!haSF[s]});
                return (<>
                    <div style={{marginBottom:"10px"}}><div style={{fontSize:"12px",fontWeight:"600",color:"#93c5fd",marginBottom:"6px"}}>Ort. Pencere (Gün)</div>
                        <select value={filtre.lookback||20} onChange={e=>set("lookback",Number(e.target.value))} style={{padding:"6px 10px",borderRadius:"7px",border:"1px solid #334155",background:"#0f172a",color:"#e2e8f0",fontSize:"13px",width:"100%"}}>
                            {[5,10,20,30,40,50].map(v=><option key={v} value={v}>{v} Gün</option>)}
                        </select>
                    </div>
                    <div style={{marginBottom:"10px"}}><div style={{fontSize:"12px",fontWeight:"600",color:"#93c5fd",marginBottom:"6px"}}>Min. Spike (×Ort.)</div>
                        <input type="number" value={filtre.min_spike||1.5} min={1.0} max={10} step={0.1} onChange={e=>set("min_spike",parseFloat(e.target.value))} style={{padding:"6px 10px",borderRadius:"7px",border:"1px solid #334155",background:"#0f172a",color:"#e2e8f0",fontSize:"13px",width:"70px"}}/>
                    </div>
                    <div style={{marginBottom:"10px"}}><div style={{fontSize:"12px",fontWeight:"600",color:"#93c5fd",marginBottom:"6px"}}>Sinyal Tipi</div>
                        <div style={{display:"flex",gap:8}}>
                            <div style={{background:"#0f172a",border:"1px solid #16a34a55",borderRadius:6,padding:"6px 10px",flex:1}}>
                                <div style={{fontSize:10,fontWeight:700,color:"#16a34a",marginBottom:4}}>📈 ALIMLAR</div>
                                {["📈 Güçlü Alım","🔶 Orta Alım","⬇️ Zayıf Alım","⚖️ Belirsiz"].map(s=>{const aktif=!!haSF[s];return(<button key={s} type="button" onClick={()=>toggleHA(s)} style={{display:"block",width:"100%",textAlign:"left",padding:"2px 6px",borderRadius:4,marginBottom:2,cursor:"pointer",fontSize:11,fontWeight:aktif?700:400,background:aktif?HA_RENK_MAP[s]+"22":"transparent",border:`1px solid ${aktif?HA_RENK_MAP[s]:"transparent"}`,color:aktif?HA_RENK_MAP[s]:"#94a3b8"}}>{s}</button>);})}
                            </div>
                            <div style={{background:"#0f172a",border:"1px solid #dc262655",borderRadius:6,padding:"6px 10px",flex:1}}>
                                <div style={{fontSize:10,fontWeight:700,color:"#dc2626",marginBottom:4}}>📉 SATIMLAR</div>
                                {["📉 Güçlü Satım","🔶 Orta Satım","⬆️ Zayıf Satım"].map(s=>{const aktif=!!haSF[s];return(<button key={s} type="button" onClick={()=>toggleHA(s)} style={{display:"block",width:"100%",textAlign:"left",padding:"2px 6px",borderRadius:4,marginBottom:2,cursor:"pointer",fontSize:11,fontWeight:aktif?700:400,background:aktif?HA_RENK_MAP[s]+"22":"transparent",border:`1px solid ${aktif?HA_RENK_MAP[s]:"transparent"}`,color:aktif?HA_RENK_MAP[s]:"#94a3b8"}}>{s}</button>);})}
                            </div>
                        </div>
                    </div>
                </>);
            }
            case "Divergence Tarama": {
                const DIV_OSC = ["RSI","MACD Histogram","Stokastik RSI","OBV"];
                const DIV_TIPLER = [{key:"Regular Bullish",ikon:"📈",renk:"#16a34a"},{key:"Regular Bearish",ikon:"📉",renk:"#dc2626"},{key:"Hidden Bullish",ikon:"🔼",renk:"#06b6d4"},{key:"Hidden Bearish",ikon:"🔽",renk:"#f59e0b"}];
                const divOsc = filtre.osilatorler || {};
                const divTip = filtre.divergence_tipleri || {};
                const toggleOsc = o => set("osilatorler",{...divOsc,[o]:!divOsc[o]});
                const toggleTip = t => set("divergence_tipleri",{...divTip,[t]:!divTip[t]});
                const ayarlarAcik = filtre.ayarlar_acik||false;
                const stochAktif = !!divOsc["Stokastik RSI"], macdAktif = !!divOsc["MACD Histogram"], rsiAktif = !!divOsc["RSI"];
                return (<>
                    <Sel alan="tarama_periyot" etiket="Periyot" opts={periyotOpts} />
                    <div style={{marginBottom:"10px"}}><div style={{fontSize:"12px",fontWeight:"600",color:"#93c5fd",marginBottom:"6px"}}>Pivot Modu</div>
                        <div style={{display:"flex",gap:6}}>{[["fractal","Fractal"],["zigzag","ZigZag"]].map(([v,l])=>{const aktif=(filtre.pivot_modu||"fractal")===v;return(<button key={v} type="button" onClick={()=>set("pivot_modu",v)} style={{padding:"5px 12px",borderRadius:8,fontSize:12,fontWeight:600,cursor:"pointer",border:`1px solid ${aktif?"#3b82f6":"#334155"}`,background:aktif?"#3b82f622":"#0f172a",color:aktif?"#3b82f6":"#94a3b8"}}>{l}</button>);})}</div>
                    </div>
                    <div style={{marginBottom:"10px"}}><div style={{fontSize:"12px",fontWeight:"600",color:"#93c5fd",marginBottom:"6px"}}>Osilatörler</div>
                        <div style={{display:"flex",flexWrap:"wrap",gap:6}}>{DIV_OSC.map(o=>{const aktif=!!divOsc[o];return(<button key={o} type="button" onClick={()=>toggleOsc(o)} style={{padding:"4px 10px",borderRadius:8,fontSize:11,cursor:"pointer",fontWeight:aktif?600:400,border:`1px solid ${aktif?"#3b82f6":"#334155"}`,background:aktif?"#3b82f618":"#0f172a",color:aktif?"#3b82f6":"#94a3b8"}}>{o}</button>);})}</div>
                    </div>
                    <div style={{marginBottom:"10px"}}><div style={{fontSize:"12px",fontWeight:"600",color:"#93c5fd",marginBottom:"6px"}}>Divergence Tipleri</div>
                        <div style={{display:"flex",flexWrap:"wrap",gap:6}}>{DIV_TIPLER.map(t=>{const aktif=!!divTip[t.key];return(<button key={t.key} type="button" onClick={()=>toggleTip(t.key)} style={{padding:"4px 10px",borderRadius:8,fontSize:11,cursor:"pointer",fontWeight:aktif?600:400,border:`1px solid ${aktif?t.renk:"#334155"}`,background:aktif?t.renk+"18":"#0f172a",color:aktif?t.renk:"#94a3b8"}}>{t.ikon} {t.key}</button>);})}</div>
                    </div>
                    <button type="button" onClick={()=>set("ayarlar_acik",!ayarlarAcik)} style={{padding:"5px 12px",borderRadius:8,border:"1px solid #334155",background:ayarlarAcik?"#334155":"#0f172a",color:"#e2e8f0",fontSize:11,fontWeight:600,cursor:"pointer",marginBottom:8}}>⚙️ Gelişmiş Ayarlar {ayarlarAcik?"▲":"▼"}</button>
                    {ayarlarAcik && (<div style={{display:"flex",flexWrap:"wrap",gap:8,marginBottom:8}}>
                        {(filtre.pivot_modu||"fractal")==="fractal"
                            ? (<div><div style={{fontSize:11,color:"#93c5fd",marginBottom:4}}>Swing Penceresi</div><input type="number" value={filtre.swing_pencere||5} min={2} max={20} onChange={e=>set("swing_pencere",parseInt(e.target.value))} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #334155",background:"#0f172a",color:"#e2e8f0",fontSize:12,width:65}}/></div>)
                            : (<div><div style={{fontSize:11,color:"#93c5fd",marginBottom:4}}>ZigZag Eşik (%)</div><input type="number" value={filtre.zigzag_esik||1} min={0.5} max={20} step={0.5} onChange={e=>set("zigzag_esik",parseFloat(e.target.value))} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #334155",background:"#0f172a",color:"#e2e8f0",fontSize:12,width:65}}/></div>)
                        }
                        <div><div style={{fontSize:11,color:"#93c5fd",marginBottom:4}}>N Son Pivot</div><div style={{display:"flex",gap:4}}>{[2,3].map(n=>{const a=(filtre.n_son_pivot||2)===n;return(<button key={n} type="button" onClick={()=>set("n_son_pivot",n)} style={{padding:"4px 8px",borderRadius:6,fontSize:12,cursor:"pointer",border:`1px solid ${a?"#3b82f6":"#334155"}`,background:a?"#3b82f622":"#0f172a",color:a?"#3b82f6":"#94a3b8"}}>{n}</button>);})}</div></div>
                        <div><div style={{fontSize:11,color:"#93c5fd",marginBottom:4}}>Min Pivot Mesafe</div><input type="number" value={filtre.min_pivot_mesafe||3} min={0} max={20} onChange={e=>set("min_pivot_mesafe",parseInt(e.target.value))} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #334155",background:"#0f172a",color:"#e2e8f0",fontSize:12,width:65}}/></div>
                        <div><div style={{fontSize:11,color:"#93c5fd",marginBottom:4}}>Min Hareket (xATR)</div><input type="number" value={filtre.min_hareket_atr||0} min={0} max={5} step={0.1} onChange={e=>set("min_hareket_atr",parseFloat(e.target.value))} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #334155",background:"#0f172a",color:"#e2e8f0",fontSize:12,width:65}}/></div>
                        {rsiAktif && <div><div style={{fontSize:11,color:"#93c5fd",marginBottom:4}}>RSI Periyot</div><input type="number" value={filtre.rsi_periyot||14} min={2} max={50} onChange={e=>set("rsi_periyot",parseInt(e.target.value))} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #334155",background:"#0f172a",color:"#e2e8f0",fontSize:12,width:65}}/></div>}
                        {macdAktif && <><div><div style={{fontSize:11,color:"#93c5fd",marginBottom:4}}>MACD Fast</div><input type="number" value={filtre.macd_fast||12} min={2} max={50} onChange={e=>set("macd_fast",parseInt(e.target.value))} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #334155",background:"#0f172a",color:"#e2e8f0",fontSize:12,width:65}}/></div><div><div style={{fontSize:11,color:"#93c5fd",marginBottom:4}}>MACD Slow</div><input type="number" value={filtre.macd_slow||26} min={5} max={100} onChange={e=>set("macd_slow",parseInt(e.target.value))} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #334155",background:"#0f172a",color:"#e2e8f0",fontSize:12,width:65}}/></div><div><div style={{fontSize:11,color:"#93c5fd",marginBottom:4}}>MACD Signal</div><input type="number" value={filtre.macd_signal||9} min={2} max={50} onChange={e=>set("macd_signal",parseInt(e.target.value))} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #334155",background:"#0f172a",color:"#e2e8f0",fontSize:12,width:65}}/></div></>}
                        {stochAktif && <><div><div style={{fontSize:11,color:"#93c5fd",marginBottom:4}}>StochRSI RSI Per.</div><input type="number" value={filtre.stoch_rsi_periyot||14} min={2} max={50} onChange={e=>set("stoch_rsi_periyot",parseInt(e.target.value))} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #334155",background:"#0f172a",color:"#e2e8f0",fontSize:12,width:65}}/></div><div><div style={{fontSize:11,color:"#93c5fd",marginBottom:4}}>StochRSI Stoch Per.</div><input type="number" value={filtre.stoch_periyot||14} min={2} max={50} onChange={e=>set("stoch_periyot",parseInt(e.target.value))} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #334155",background:"#0f172a",color:"#e2e8f0",fontSize:12,width:65}}/></div><div><div style={{fontSize:11,color:"#93c5fd",marginBottom:4}}>%K</div><input type="number" value={filtre.stoch_k||3} min={1} max={20} onChange={e=>set("stoch_k",parseInt(e.target.value))} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #334155",background:"#0f172a",color:"#e2e8f0",fontSize:12,width:55}}/></div><div><div style={{fontSize:11,color:"#93c5fd",marginBottom:4}}>%D</div><input type="number" value={filtre.stoch_d||3} min={1} max={20} onChange={e=>set("stoch_d",parseInt(e.target.value))} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #334155",background:"#0f172a",color:"#e2e8f0",fontSize:12,width:55}}/></div></>}
                    </div>)}
                </>);
            }
            default: return null;
        }
    };

    return (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.55)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000}}>
            <div style={{background:"#1e293b",border:"1px solid #334155",borderRadius:"14px",padding:"1.75rem",width:"500px",maxWidth:"95vw",maxHeight:"85vh",overflowY:"auto",boxShadow:"0 12px 48px rgba(0,0,0,0.5)",color:"#e2e8f0"}}>
                <div style={{fontSize:"18px",fontWeight:"700",color:"#e2e8f0",marginBottom:"0.5rem"}}>🔗 Çoklu Taramaya Gönder</div>
                <p style={{fontSize:"13px",color:"#94a3b8",marginBottom:"1.25rem"}}>
                    <strong>{secilenSayisi}</strong> sembol seçili. Devam edilecek modülü ve kriterleri seçin.
                </p>
                <div style={{marginBottom:"1.25rem"}}>
                    <div style={{fontSize:"12px",fontWeight:"600",color:"#93c5fd",marginBottom:"8px"}}>Modül Seçin</div>
                    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"6px"}}>
                        {COKLU_MODULLER.map(m => (
                            <button key={m.value} type="button" disabled={m.pasif} onClick={() => onModulSec(m.value)}
                                style={{padding:"8px 10px",borderRadius:"8px",fontSize:"12px",textAlign:"left",cursor:m.pasif?"not-allowed":"pointer",
                                    border:`2px solid ${secilenModul===m.value?"#3b82f6":"#334155"}`,
                                    background:secilenModul===m.value?"#3b82f622":"transparent",
                                    color:m.pasif?"#475569":(secilenModul===m.value?"#3b82f6":"#e2e8f0"),
                                    fontWeight:secilenModul===m.value?"700":"400",opacity:m.pasif?0.5:1}}>
                                {m.label}{m.pasif&&" (yakında)"}
                            </button>
                        ))}
                    </div>
                </div>
                {secilenModul && (
                    <div style={{background:"#0f172a",border:"1px solid #334155",borderRadius:"8px",padding:"10px 14px",marginBottom:"1rem",display:"flex",gap:"20px"}}>
                        <div><div style={{fontSize:"11px",color:"#9ca3af",fontWeight:"500"}}>Piyasa</div><div style={{fontSize:"13px",fontWeight:"600",color:"#e2e8f0"}}>🔒 {piyasa}</div></div>
                        <div><div style={{fontSize:"11px",color:"#9ca3af",fontWeight:"500"}}>Para Birimi</div><div style={{fontSize:"13px",fontWeight:"600",color:"#e2e8f0"}}>🔒 {paraBirimi}</div></div>
                    </div>
                )}
                {secilenModul && filtre && (
                    <div style={{marginBottom:"1.25rem"}}>
                        <div style={{fontSize:"12px",fontWeight:"600",color:"#93c5fd",marginBottom:"10px"}}>Tarama Kriterleri</div>
                        {renderFiltreler()}
                    </div>
                )}
                <div style={{display:"flex",gap:"8px",justifyContent:"flex-end"}}>
                    <button onClick={onIptal} style={{padding:"8px 18px",borderRadius:"8px",border:"1px solid #334155",background:"transparent",cursor:"pointer",fontSize:"13px",color:"#94a3b8"}}>İptal</button>
                    <button onClick={onBaslat} disabled={!secilenModul}
                        style={{padding:"8px 20px",borderRadius:"8px",border:"none",background:secilenModul?"linear-gradient(135deg,#1d4ed8,#3b82f6)":"#475569",color:"white",cursor:secilenModul?"pointer":"default",fontSize:"13px",fontWeight:"600"}}>
                        Taramayı Başlat →
                    </button>
                </div>
            </div>
        </div>
    );
}

// ─── İndir Menüsü (Excel / CSV / PDF / SVG) ──────────────────────────────────
function IndirMenusu({ veri, setIslemMenuAcik }) {
    const [acik, setAcik] = useState(false);
    const dosyaAdi = `birlesik_skor_${new Date().toLocaleDateString("tr-TR").replace(/\./g, "-")}`;

    const indir = async (fmt) => {
        setAcik(false); setIslemMenuAcik(false);
        if (!veri?.length) return;
        if (fmt === "xlsx") {
            const ws = XLSX.utils.json_to_sheet(veri);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Birleşik Skor");
            XLSX.writeFile(wb, `${dosyaAdi}.xlsx`);
        } else if (fmt === "csv") {
            const h = Object.keys(veri[0] || {});
            const rows = veri.map(r => h.map(k => { const v = String(r[k] ?? ""); return v.includes(",") || v.includes('"') ? `"${v.replace(/"/g, '""')}"` : v; }).join(","));
            const blob = new Blob(["\uFEFF" + [h.join(","), ...rows].join("\n")], { type: "text/csv;charset=utf-8;" });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a"); a.href = url; a.download = `${dosyaAdi}.csv`; a.click(); URL.revokeObjectURL(url);
        } else if (fmt === "pdf") {
            try {
                const { default: jsPDF } = await import("jspdf");
                const { default: autoTable } = await import("jspdf-autotable");
                const h = Object.keys(veri[0] || {});
                const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "a4" });
                doc.setFontSize(14); doc.text("Birleşik Skor Sonuçları", 20, 30);
                doc.setFontSize(9); doc.setTextColor(100);
                doc.text(`${veri.length} kayıt · ${new Date().toLocaleDateString("tr-TR")}`, 20, 48);
                autoTable(doc, {
                    head: [h], body: veri.map(r => h.map(k => String(r[k] ?? ""))), startY: 58,
                    styles: { fontSize: 7, cellPadding: 3 },
                    headStyles: { fillColor: [124, 58, 237], textColor: 255, fontStyle: "bold" },
                    alternateRowStyles: { fillColor: [245, 247, 250] },
                });
                doc.save(`${dosyaAdi}.pdf`);
            } catch { toast.error("PDF oluşturulamadı"); indir("svg"); }
        } else if (fmt === "svg") {
            const h = Object.keys(veri[0] || {});
            const cw = Math.max(60, Math.floor(740 / h.length)), rh = 18, hh = 24, tw = cw * h.length;
            const pw = Math.max(tw + 40, 800), ph = 80 + hh + veri.length * rh;
            const esc = s => String(s).slice(0, 18).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
            const rows = veri.map((r, i) => `<g transform="translate(20,${60 + hh + i * rh})"><rect width="${tw}" height="${rh}" fill="${i % 2 === 0 ? "#1e293b" : "#0f172a"}" stroke="#334155" stroke-width="0.5"/>${h.map((k, j) => `<text x="${j * cw + 4}" y="13" font-size="9" fill="#e2e8f0" font-family="Arial">${esc(r[k])}</text>`).join("")}</g>`).join("");
            const heads = h.map((k, j) => `<text x="${20 + j * cw + 4}" y="48" font-size="9" font-weight="bold" fill="white" font-family="Arial">${esc(k)}</text>`).join("");
            const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${pw}" height="${ph}"><rect width="${pw}" height="${ph}" fill="#0f172a"/><text x="20" y="22" font-size="14" font-weight="bold" fill="#e2e8f0" font-family="Arial">Birleşik Skor Sonuçları</text><text x="20" y="38" font-size="10" fill="#94a3b8" font-family="Arial">${veri.length} kayıt · ${new Date().toLocaleDateString("tr-TR")}</text><rect x="20" y="52" width="${tw}" height="${hh}" fill="#7c3aed"/>${heads}${rows}</svg>`;
            const blob = new Blob([svg], { type: "image/svg+xml" });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a"); a.href = url; a.download = `${dosyaAdi}.svg`; a.click(); URL.revokeObjectURL(url);
        }
    };

    return (
        <div style={{ position: "relative" }} onMouseEnter={() => setAcik(true)} onMouseLeave={() => setAcik(false)}>
            <button style={{ display: "flex", width: "100%", textAlign: "left", justifyContent: "space-between",
                padding: "10px 16px", border: "none", background: "none", cursor: "pointer",
                color: C.text, fontSize: 13, borderBottom: `1px solid ${C.border}` }}>
                📥 İndir <span style={{ color: C.muted }}>▶</span>
            </button>
            {acik && (
                <div style={{ position: "absolute", left: "100%", top: 0, background: C.panel,
                    border: `1px solid ${C.border}`, borderRadius: 8,
                    boxShadow: "0 8px 24px rgba(0,0,0,0.4)", minWidth: 160, overflow: "hidden", zIndex: 101 }}>
                    {[{ l: "Excel (.xlsx)", f: "xlsx" }, { l: "CSV (.csv)", f: "csv" }, { l: "PDF (.pdf)", f: "pdf" }, { l: "SVG (.svg)", f: "svg" }].map(s => (
                        <button key={s.f} onClick={() => indir(s.f)}
                            style={{ display: "block", width: "100%", textAlign: "left", padding: "9px 14px",
                                border: "none", background: "none", cursor: "pointer", color: C.text, fontSize: 13,
                                borderBottom: `1px solid ${C.border}` }}>{s.l}</button>
                    ))}
                </div>
            )}
        </div>
    );
}

// ─── Ana Bileşen ─────────────────────────────────────────────────────────────
export default function BirlesikSkorTarama() {
    const navigate = useNavigate();

    const [mod,          setMod]          = useState("BIST");
    const [paraBirimi,   setParaBirimi]   = useState("USD");
    const [piyasaSecenekleri,     setPiyasaSecenekleri]     = useState(["BIST", "Kripto"]);
    const [paraBirimiSecenekleri, setParaBirimiSecenekleri] = useState(["USD", "USD (Futures)"]);
    const [calisiyor,    setCalisiyor]    = useState(false);
    const [sonuc,        setSonuc]        = useState(null);
    const [aramaMetni,   setAramaMetni]   = useState("");
    const [filtre,       setFiltre]       = useState("HEPSI");
    const [minKonfidans, setMinKonfidans] = useState(0);
    const [minConfluence,setMinConfluence]= useState(3);
    const [yonFiltre,    setYonFiltre]    = useState("HEPSI"); // HEPSI | ALIŞ | SATIŞ
    const [secilenler,   setSecilenler]   = useState(new Set());
    const [listelenen,   setListelenen]   = useState(null);
    const [bilgiKarti,   setBilgiKarti]   = useState(null);
    const [dogrulukKaydediliyor, setDogrulukKaydediliyor] = useState(false);
    const [dogrulukPopup, setDogrulukPopup] = useState(null); // null | "yukleniyor" | "tamam"
    const [dogrulukSonuc, setDogrulukSonuc] = useState(null);
    const [alarmPopup,       setAlarmPopup]       = useState(false);
    const [alarmHisseler,    setAlarmHisseler]    = useState([]);
    const [hedefFiyatlar,    setHedefFiyatlar]    = useState({});
    const [alarmMail,        setAlarmMail]        = useState(false);
    const [alarmBildirim,    setAlarmBildirim]    = useState(true);
    const [alarmKaydediliyor,setAlarmKaydediliyor]= useState(false);
    const [cokluPopup,     setCokluPopup]     = useState(false);
    const [cokluSecModul,  setCokluSecModul]  = useState(null);
    const [cokluFiltre,    setCokluFiltre]    = useState(null);
    const [cokluOnayPopup, setCokluOnayPopup] = useState(false);
    const [cokluPeriyotlar,setCokluPeriyotlar]= useState([]);
    const [puanlamaPopupAdim,setPuanlamaPopupAdim] = useState(null); // "kriter" | "onay"
    const [puanlamaVade,   setPuanlamaVade]   = useState(null);
    const [puanlamaYon,    setPuanlamaYon]    = useState(new Set(["Long", "Short"]));
    const [puanlamaMinPuan,setPuanlamaMinPuan]= useState(0);
    const [detaySatir,   setDetaySatir]   = useState(null);
    const [listelenenMod,setListelenenMod]= useState("BIST");
    const [islemMenuAcik,setIslemMenuAcik]= useState(false);

    const [taramaDurum,  setTaramaDurum]   = useState(null);
    const pollRef      = useRef(null);
    const menuRef      = useRef(null);
    const taramaBasRef = useRef(null);

    useEffect(() => () => {
        if (pollRef.current) clearInterval(pollRef.current);
    }, []);

    // Piyasa ve Para Birimi seçeneklerini DB'den çek
    useEffect(() => {
        (async () => {
            try {
                const [p, pb] = await Promise.all([
                    getLookupPiyasalar(),
                    getLookupParaBirimleri(mod, "birlesik_skor"),
                ]);
                if (p?.length)  setPiyasaSecenekleri(p);
                if (pb?.length) {
                    setParaBirimiSecenekleri(pb);
                    if (!pb.includes(paraBirimi)) setParaBirimi(pb[0]);
                }
            } catch {}
        })();
    }, []);

    useEffect(() => {
        getLookupParaBirimleri(mod, "birlesik_skor")
            .then(pb => {
                if (pb?.length) {
                    setParaBirimiSecenekleri(pb);
                    if (!pb.includes(paraBirimi)) setParaBirimi(pb[0]);
                }
            })
            .catch(() => {});
    }, [mod]);

    useEffect(() => {
        const handler = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                setIslemMenuAcik(false);
            }
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);

    async function taramaBaslat() {
        setCalisiyor(true);
        setTaramaDurum({ ilerleme: 0, mesaj: "Başlatılıyor...", tamamlanan: 0, toplam: 0, aktif: "", bulunan: 0, calisiyor: true });
        setSonuc(null);
        setListelenen(null);
        setSecilenler(new Set());
        taramaBasRef.current = Date.now();
        try {
            const token = await getToken();
            await axios.post(
                `${API_URL}/scan/birlesik-skor/tara`,
                { mod, para_birimi: paraBirimi, min_konfidans: 0 },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            if (pollRef.current) clearInterval(pollRef.current);
            pollRef.current = setInterval(async () => {
                try {
                    const t = await getToken();
                    const res = await axios.get(`${API_URL}/scan/durum`, {
                        headers: { Authorization: `Bearer ${t}` },
                    });
                    const d = res.data;
                    const gecenSn = Math.round((Date.now() - taramaBasRef.current) / 1000);
                    const parca = (d.mesaj || "").split("|");
                    const tamamlanan = parca.length === 3 ? parseInt(parca[1]?.split("/")[0]) || 0 : (d.tamamlanan || 0);
                    const toplam     = parca.length === 3 ? parseInt(parca[1]?.split("/")[1]) || 0 : (d.toplam || 0);
                    const aktifSembol = parca.length === 3 ? parca[2] : "";
                    const bulunan    = parca.length === 3 ? parseInt(parca[0]) || 0 : (d.bulunan || 0);
                    setTaramaDurum({
                        ilerleme:   d.ilerleme || 0,
                        mesaj:      d.mesaj || "",
                        tamamlanan, toplam, aktif: aktifSembol, bulunan,
                        gecen:      gecenSn,
                        calisiyor:  d.calisiyor,
                    });
                    if (!d.calisiyor) {
                        clearInterval(pollRef.current);
                        setCalisiyor(false);
                        setTaramaDurum(null);
                        if (d.sonuc) {
                            setListelenen(d.sonuc);
                            setListelenenMod(mod);
                            toast.success(`${d.sonuc.toplam} sembol skorlandı.`);
                        } else if (d.hata) {
                            toast.error("Hata: " + d.hata);
                        }
                    }
                } catch {}
            }, 3000);
        } catch (e) {
            toast.error("Tarama başlatılamadı: " + e.message);
            setCalisiyor(false);
            setTaramaDurum(null);
        }
    }

    const veriKaynagi = listelenen || sonuc;
    const filtrelenmis = (veriKaynagi?.sonuclar || []).filter(r => {
        const aramaOk    = !aramaMetni || r.symbol?.toLowerCase().includes(aramaMetni.toLowerCase());
        const filtreOk   = filtre === "HEPSI" || r.kademe === filtre;
        const konfOk     = r.konfidans >= minKonfidans;
        const conflOk    = (r.aktif_modul_sayisi || 0) >= minConfluence;
        const yonOk      = yonFiltre === "HEPSI" || r.yon === yonFiltre;
        return aramaOk && filtreOk && konfOk && conflOk && yonOk;
    });

    const kademeGrup = (veriKaynagi?.sonuclar || []).reduce((acc, r) => {
        acc[r.kademe] = (acc[r.kademe] || 0) + 1;
        return acc;
    }, {});

    const toggleSec = (sym) => setSecilenler(p => {
        const n = new Set(p);
        n.has(sym) ? n.delete(sym) : n.add(sym);
        return n;
    });
    const toggleTum = () => {
        if (secilenler.size === filtrelenmis.length) setSecilenler(new Set());
        else setSecilenler(new Set(filtrelenmis.map(r => r.symbol)));
    };
    const tumSecili = filtrelenmis.length > 0 && secilenler.size === filtrelenmis.length;

    // ── Seçili sembol listesi (ve fiyatları) ─────────────────────────────────
    const seciliSemboller = () =>
        (veriKaynagi?.sonuclar || [])
            .filter(r => secilenler.has(r.symbol))
            .map(r => ({ sembol: r.symbol, fiyat: r.fiyat }));

    // ── İşlemler: Doğruluk Analizine Gönder (yakında) ────────────────────────
    // (şimdilik pasif — sonraki aşamada devreye alınacak)

    // ── İşlemler: Geçmiş Simülasyonuna Gönder ────────────────────────────────
    const gecmisSimGonder = () => {
        if (secilenler.size === 0) { toast.error("Önce sembol seçin"); return; }
        setIslemMenuAcik(false);
        navigate("/gecmis-simulasyon", {
            state: { kaynak: "birlesik_skor", mod, para_birimi: paraBirimi,
                     hisse_listesi: [...secilenler] },
        });
    };

    // ── İşlemler: Çoklu Taramaya Gönder ───────────────────────────────────────
    const cokluTaramayaGonder = () => {
        if (secilenler.size === 0) { toast.error("Önce sembol seçin"); return; }
        setCokluSecModul(null);
        setCokluFiltre(null);
        setCokluPeriyotlar([]);
        setCokluPopup(true);
        setIslemMenuAcik(false);
    };

    const COKLU_DB_KEY_MAP = {
        "Dip Tarama": "dip_tarama", "Likidite Tarama": "likidite_tarama", "FVG Tarama": "fvg_tarama",
        "Çapa Noktası Tarama": "capa_noktasi_tarama", "MSB Tarama": "msb_tarama", "OTE Tarama": "ote_tarama",
        "OB & BB Tarama": "obbb_tarama", "IDM Tarama": "idm_tarama", "P/D Zone Tarama": "pd_zone_tarama",
        "Korelasyonel Uyumsuzluk Tarama": "smt_tarama", "Killzone Tarama": "killzone_tarama",
        "Topdown Cascade": "topdown_cascade_tarama", "Hacim Profili Tarama": "hacim_profili_tarama",
        "Hacim Akışı Tarama": "hacim_akisi_tarama", "Divergence Tarama": "divergence_tarama",
    };

    const cokluModulSec = (m) => {
        setCokluSecModul(m);
        setCokluFiltre(defaultCokluFiltreler(m, mod));
        const dbKey = COKLU_DB_KEY_MAP[m];
        if (dbKey) getLookupPeriyotlar(dbKey).then(list => setCokluPeriyotlar(list)).catch(() => setCokluPeriyotlar([]));
        else setCokluPeriyotlar([]);
    };

    // ── İşlemler: Puanlamaya Gönder ───────────────────────────────────────────
    const puanlamayaGonder = () => {
        if (secilenler.size === 0) { toast.error("Önce sembol seçin"); return; }
        const bistOpts = ["Gün İçi", "Kısa Vade (1-10 gün)", "Orta Vade (11-60 gün)", "Uzun Vade (61+ gün)"];
        const varsayilanVade = mod === "Kripto"
            ? (paraBirimi === "USD (Futures)" ? "Kaldıraçlı İşlem" : "Gün İçi")
            : bistOpts[0];
        setPuanlamaVade(varsayilanVade);
        setPuanlamaYon(new Set(["Long", "Short"]));
        setPuanlamaMinPuan(0);
        setPuanlamaPopupAdim("kriter");
        setIslemMenuAcik(false);
    };

    // ── İşlemler: Alarm Ekle ──────────────────────────────────────────────────
    const alarmAc = () => {
        if (secilenler.size === 0) { toast.error("Önce sembol seçin"); return; }
        setAlarmHisseler(seciliSemboller());
        setHedefFiyatlar({});
        setAlarmMail(false);
        setAlarmBildirim(true);
        setAlarmPopup(true);
        setIslemMenuAcik(false);
    };

    const alarmKaydet = async () => {
        const eksik = alarmHisseler.find(h => !hedefFiyatlar[h.sembol] || isNaN(parseFloat(hedefFiyatlar[h.sembol])));
        if (eksik) { toast.error(`${eksik.sembol} için hedef fiyat girin`); return; }
        setAlarmKaydediliyor(true);
        try {
            const { data: { session } } = await supabase.auth.getSession();
            for (const h of alarmHisseler) {
                const fiyat = parseFloat(h.fiyat);
                const hedef = parseFloat(hedefFiyatlar[h.sembol]);
                const pot = fiyat > 0 ? ((hedef - fiyat) / fiyat * 100).toFixed(2) : null;
                const { error } = await supabase.from("alerts").insert({
                    piyasa: mod, sembol: h.sembol, para_birimi: paraBirimi || "USD",
                    fiyat, hedef_fiyat: hedef, potansiyel: pot ? parseFloat(pot) : null,
                    bildirim_mail: alarmMail, bildirim_popup: alarmBildirim,
                    user_id: session.user.id,
                });
                if (error) throw error;
            }
            toast.success(`${alarmHisseler.length} alarm eklendi!`);
            setAlarmPopup(false);
            setAlarmHisseler([]);
        } catch (e) {
            toast.error("Alarm kaydedilemedi: " + e.message);
        } finally {
            setAlarmKaydediliyor(false);
        }
    };

    // ── İşlemler: Doğruluk Analizine Gönder ──────────────────────────────────
    const dogrulukKaydet = async () => {
        if (secilenler.size === 0) { toast.error("Önce sembol seçin"); return; }
        setIslemMenuAcik(false);
        setDogrulukKaydediliyor(true);
        setDogrulukPopup("yukleniyor");
        setDogrulukSonuc(null);
        await new Promise(r => setTimeout(r, 50));
        try {
            const token = await getToken();
            const seciliH = (veriKaynagi?.sonuclar || []).filter(r => secilenler.has(r.symbol));
            const res = await axios.post(
                `${API_URL}/scan/birlesik-skor-tarama-analiz/kaydet`,
                { hisseler: seciliH, mod, para_birimi: paraBirimi || "USD" },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setDogrulukSonuc(res.data);
            setDogrulukPopup("tamam");
        } catch (e) {
            toast.error("Kaydedilemedi: " + (e.response?.data?.detail || e.message));
            setDogrulukPopup(null);
        } finally {
            setDogrulukKaydediliyor(false);
        }
    };

    // ── İşlemler: İzleme Listesine Ekle ──────────────────────────────────────
    const izlemeListesineEkle = async () => {
        if (secilenler.size === 0) { toast.error("Önce sembol seçin"); return; }
        setIslemMenuAcik(false);
        try {
            const { data: { session } } = await supabase.auth.getSession();
            const kayitlar = [...secilenler].map(sembol => ({
                user_id: session.user.id, sembol, piyasa: mod, kaynak: "birlesik_skor",
            }));
            const { error } = await supabase.from("izleme_listesi").insert(kayitlar);
            if (error) throw error;
            toast.success(`${secilenler.size} sembol izleme listesine eklendi.`);
        } catch (e) {
            toast.error("İzleme listesine eklenemedi: " + e.message);
        }
    };


    return (
        <div style={{ padding: 24, background: C.bg, minHeight: "100vh", color: C.text, fontFamily: "system-ui,sans-serif" }}>
            {bilgiKarti && <BilgiKarti karti={bilgiKarti} kapat={() => setBilgiKarti(null)} />}
            {detaySatir && <DetayPaneli satir={detaySatir} kapat={() => setDetaySatir(null)} setBilgiKarti={setBilgiKarti} />}
            {/* Doğruluk Popup */}
            {dogrulukPopup && (
                <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)",
                    display: "flex", alignItems: "center", justifyContent: "center", zIndex: 2000 }}>
                    <div style={{ background: C.panel, border: `1px solid ${C.border}`, borderRadius: 14,
                        padding: "2rem", width: 420, maxWidth: "95vw", boxShadow: "0 12px 48px rgba(0,0,0,0.5)" }}>
                        {dogrulukPopup === "yukleniyor" ? (
                            <>
                                <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20 }}>
                                    <span style={{ fontSize: 24 }}>✅</span>
                                    <div>
                                        <div style={{ fontSize: 16, fontWeight: 700, color: C.text }}>Doğruluk Analizi</div>
                                        <div style={{ fontSize: 12, color: C.muted, marginTop: 2 }}>Veriler kaydediliyor...</div>
                                    </div>
                                </div>
                                <HareketliBar />
                                <div style={{ fontSize: 13, color: C.muted, textAlign: "center" }}>Kaydediliyor...</div>
                            </>
                        ) : (
                            <>
                                <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20 }}>
                                    <span style={{ fontSize: 28 }}>✅</span>
                                    <div style={{ fontSize: 16, fontWeight: 700, color: C.text }}>Kayıt Tamamlandı</div>
                                </div>
                                <div style={{ background: C.bullish + "22", border: `1px solid ${C.bullish}44`,
                                    borderRadius: 8, padding: "14px 16px", marginBottom: 20, fontSize: 14, color: C.bullish, lineHeight: 1.6 }}>
                                    Seçilen semboller <strong>"Doğruluk Analizi"</strong> veri tabanına kaydedildi.
                                    {dogrulukSonuc && (
                                        <div style={{ marginTop: 8, fontSize: 12, color: C.muted }}>
                                            {dogrulukSonuc.toplam ? <span>✔ {dogrulukSonuc.toplam} kayıt işleme alındı</span>
                                                : dogrulukSonuc.eklenen != null && <span>✔ {dogrulukSonuc.eklenen} yeni · {dogrulukSonuc.atlanan} mevcut</span>}
                                        </div>
                                    )}
                                </div>
                                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                    <button onClick={() => { setDogrulukPopup(null); setDogrulukSonuc(null); }}
                                        style={{ padding: "8px 28px", borderRadius: 8, border: "none",
                                            background: "linear-gradient(135deg,#1d4ed8,#3b82f6)",
                                            color: "white", cursor: "pointer", fontSize: 14, fontWeight: 600 }}>
                                        Tamam
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            )}

            {alarmPopup && (
                <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)",
                    display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 }}>
                    <div style={{ background: C.panel, border: `1px solid ${C.border}`, borderRadius: 14,
                        padding: "1.75rem", width: 460, maxWidth: "95vw", maxHeight: "85vh", overflowY: "auto",
                        boxShadow: "0 12px 48px rgba(0,0,0,0.5)", color: C.text }}>
                        <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 4 }}>⏰ Alarm Ekle</div>
                        <p style={{ fontSize: 13, color: C.muted, marginBottom: 16 }}>
                            <strong>{alarmHisseler.length}</strong> sembol için hedef fiyat girin.
                        </p>
                        <div style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 16 }}>
                            {alarmHisseler.map(h => (
                                <div key={h.sembol} style={{ display: "flex", alignItems: "center", gap: 10,
                                    background: C.bg, border: `1px solid ${C.border}`, borderRadius: 8, padding: "8px 12px" }}>
                                    <span style={{ fontWeight: 700, color: C.accent, minWidth: 80 }}>{h.sembol}</span>
                                    <span style={{ fontSize: 12, color: C.muted, minWidth: 90 }}>
                                        Şu an: {h.fiyat != null ? h.fiyat : "—"}
                                    </span>
                                    <input type="number" placeholder="Hedef fiyat" value={hedefFiyatlar[h.sembol] || ""}
                                        onChange={e => setHedefFiyatlar(p => ({ ...p, [h.sembol]: e.target.value }))}
                                        style={{ flex: 1, padding: "6px 10px", borderRadius: 6, border: `1px solid ${C.border}`,
                                            background: C.panel, color: C.text, fontSize: 13, outline: "none" }} />
                                </div>
                            ))}
                        </div>
                        <div style={{ display: "flex", gap: 16, marginBottom: 20 }}>
                            <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, cursor: "pointer" }}>
                                <input type="checkbox" checked={alarmBildirim} onChange={e => setAlarmBildirim(e.target.checked)} /> Uygulama içi bildirim
                            </label>
                            <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, cursor: "pointer" }}>
                                <input type="checkbox" checked={alarmMail} onChange={e => setAlarmMail(e.target.checked)} /> E-posta bildirimi
                            </label>
                        </div>
                        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
                            <button onClick={() => { setAlarmPopup(false); setAlarmHisseler([]); }}
                                style={{ padding: "8px 18px", borderRadius: 8, border: `1px solid ${C.border}`,
                                    background: "transparent", cursor: "pointer", fontSize: 13, color: C.muted }}>İptal</button>
                            <button onClick={alarmKaydet} disabled={alarmKaydediliyor}
                                style={{ padding: "8px 20px", borderRadius: 8, border: "none",
                                    background: alarmKaydediliyor ? C.border : "linear-gradient(135deg,#1d4ed8,#3b82f6)",
                                    color: "white", cursor: alarmKaydediliyor ? "not-allowed" : "pointer", fontSize: 13, fontWeight: 600 }}>
                                {alarmKaydediliyor ? "Kaydediliyor..." : "Alarmları Kaydet"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Çoklu Taramaya Gönder */}
            {cokluPopup && (
                <CokluTaramaGonderPopup
                    piyasa={mod}
                    paraBirimi={paraBirimi}
                    secilenSayisi={secilenler.size}
                    secilenModul={cokluSecModul}
                    filtre={cokluFiltre}
                    periyotlar={cokluPeriyotlar}
                    onModulSec={cokluModulSec}
                    onFiltreDegis={setCokluFiltre}
                    onIptal={() => { setCokluPopup(false); setCokluSecModul(null); setCokluFiltre(null); }}
                    onBaslat={() => {
                        if (!cokluSecModul || !cokluFiltre) { toast.error("Modül seçin"); return; }
                        setCokluPopup(false); setCokluOnayPopup(true);
                    }}
                />
            )}

            {/* Çoklu Onay */}
            {cokluOnayPopup && (
                <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 }}>
                    <div style={{ background: "#1e293b", border: "1px solid #334155", borderRadius: "14px", padding: "1.75rem", width: "420px", maxWidth: "95vw", boxShadow: "0 12px 48px rgba(0,0,0,0.5)", color: "#e2e8f0" }}>
                        <div style={{ fontSize: "17px", fontWeight: "700", color: "#e2e8f0", marginBottom: "0.75rem" }}>⚠️ Sayfadan Ayrılıyorsunuz</div>
                        <div style={{ background: "#422006", border: "1px solid #92400e", borderRadius: "8px", padding: "1rem", marginBottom: "1.25rem", fontSize: "13px", color: "#fde68a", lineHeight: "1.7" }}>
                            Başka bir sayfaya yönlendiriliyorsunuz. <strong>Bu sayfadaki tarama sonuçları kaybolacak.</strong>
                            <br /><br />Devam etmek istiyor musunuz?
                        </div>
                        <div style={{ display: "flex", gap: "8px", justifyContent: "flex-end" }}>
                            <button onClick={() => { setCokluOnayPopup(false); setCokluPopup(true); }}
                                style={{ padding: "8px 18px", borderRadius: "8px", border: "1px solid #334155", background: "transparent", cursor: "pointer", fontSize: "13px", color: "#94a3b8" }}>
                                ← Geri Dön
                            </button>
                            <button onClick={() => {
                                const hisseListesi = [...secilenler];
                                setCokluOnayPopup(false);
                                navigate("/coklu-tarama", { state: {
                                    kaynak: "birlesik_skor", piyasa: mod, paraBirimi,
                                    kaynakModul: "Birleşik Skor",
                                    kaynakFiltre: { min_konfidans: minKonfidans, min_confluence: minConfluence },
                                    kaynakSonucHisseler: hisseListesi,
                                    modul: cokluSecModul, filtre: cokluFiltre,
                                    hisseListesi, oto_baslat: true,
                                } });
                            }}
                                style={{ padding: "8px 20px", borderRadius: "8px", border: "none", background: "linear-gradient(135deg,#1d4ed8,#3b82f6)", color: "white", cursor: "pointer", fontSize: "13px", fontWeight: "600" }}>
                                Evet, Devam Et →
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Puanlama Kriter */}
            {puanlamaPopupAdim === "kriter" && (() => {
                const bistOpts   = ["Gün İçi", "Kısa Vade (1-10 gün)", "Orta Vade (11-60 gün)", "Uzun Vade (61+ gün)"];
                const kriptoOpts = ["Kaldıraçlı İşlem", "Gün İçi", "Kısa Vade (1-10 gün)", "Orta Vade (11-60 gün)", "Uzun Vade (61+ gün)"];
                const vadeOpts   = mod === "Kripto" ? kriptoOpts : bistOpts;
                const kaldirac   = puanlamaVade === "Kaldıraçlı İşlem";
                const minPuanOpts = [0, 25, 50, 60, 75];
                const toggleYon = y => setPuanlamaYon(prev => {
                    const n = new Set(prev);
                    if (n.has(y)) { if (n.size === 1) return prev; n.delete(y); } else n.add(y);
                    return n;
                });
                return (
                    <div style={popupStyles.overlay}>
                        <div style={{ ...popupStyles.modal, width: "420px" }}>
                            <div style={popupStyles.baslik}>🏆 Puanlamaya Gönder</div>
                            <p style={{ fontSize: "13px", color: "#94a3b8", marginBottom: "1.25rem" }}>
                                <strong>{secilenler.size}</strong> sembol seçildi. Puanlama kriterlerini belirleyin.
                            </p>
                            <div style={{ display: "flex", gap: "8px", marginBottom: "1.25rem" }}>
                                {[["Piyasa", mod], ["Para Birimi", paraBirimi]].map(([et, d]) => (
                                    <div key={et} style={{ flex: 1, background: "#0f172a", border: "1px solid #334155", borderRadius: "8px", padding: "10px 14px" }}>
                                        <div style={{ fontSize: "11px", color: "#64748b", fontWeight: "500", marginBottom: "2px" }}>{et} (kilitli)</div>
                                        <div style={{ fontSize: "14px", fontWeight: "600", color: "#e2e8f0" }}>🔒 {d}</div>
                                    </div>
                                ))}
                            </div>
                            <div style={{ marginBottom: "1.25rem" }}>
                                <label style={{ fontSize: "12px", fontWeight: "600", color: "#93c5fd", display: "block", marginBottom: "6px" }}>📅 Vade</label>
                                <select value={puanlamaVade || ""} onChange={e => setPuanlamaVade(e.target.value)}
                                    style={{ width: "100%", padding: "9px 12px", borderRadius: "8px", border: "1px solid #334155", fontSize: "13px", background: "#0f172a", color: "#e2e8f0", cursor: "pointer" }}>
                                    {vadeOpts.map(o => {
                                        const isFutures = mod === "Kripto" && paraBirimi === "USD (Futures)";
                                        const isSpot    = mod === "Kripto" && paraBirimi !== "USD (Futures)";
                                        const disabled  = (isFutures && o !== "Kaldıraçlı İşlem")
                                                       || (isSpot    && o === "Kaldıraçlı İşlem");
                                        return <option key={o} value={o} disabled={disabled}>{o}</option>;
                                    })}
                                </select>
                            </div>
                            {kaldirac && (
                                <div style={{ marginBottom: "1.25rem" }}>
                                    <div style={{ fontSize: "12px", fontWeight: "600", color: "#93c5fd", marginBottom: "8px" }}>📈 İşlem Yönü</div>
                                    <div style={{ display: "flex", gap: "8px" }}>
                                        {["Long", "Short"].map(y => (
                                            <button key={y} type="button" onClick={() => toggleYon(y)}
                                                style={{ flex: 1, padding: "10px", borderRadius: "8px", cursor: "pointer", fontSize: "13px", fontWeight: "600",
                                                    border: puanlamaYon.has(y) ? "2px solid #3b82f6" : "2px solid #334155",
                                                    background: puanlamaYon.has(y) ? (y === "Long" ? "#052e16" : "#450a0a") : "transparent",
                                                    color: puanlamaYon.has(y) ? (y === "Long" ? "#4ade80" : "#f87171") : "#64748b" }}>
                                                {y === "Long" ? "📈 Long" : "📉 Short"}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            )}
                            <div style={{ marginBottom: "1.5rem" }}>
                                <label style={{ fontSize: "12px", fontWeight: "600", color: "#93c5fd", display: "block", marginBottom: "8px" }}>🎯 Minimum Puan</label>
                                <div style={{ display: "flex", gap: "6px" }}>
                                    {minPuanOpts.map(p => (
                                        <button key={p} type="button" onClick={() => setPuanlamaMinPuan(p)}
                                            style={{ flex: 1, padding: "8px 4px", borderRadius: "8px", cursor: "pointer", fontSize: "13px",
                                                fontWeight: puanlamaMinPuan === p ? "700" : "400",
                                                border: puanlamaMinPuan === p ? "2px solid #3b82f6" : "2px solid #334155",
                                                background: puanlamaMinPuan === p ? "#2563eb" : "transparent",
                                                color: puanlamaMinPuan === p ? "white" : "#e2e8f0" }}>
                                            {p === 0 ? "0+" : `${p}+`}
                                        </button>
                                    ))}
                                </div>
                            </div>
                            <div style={{ display: "flex", gap: "8px", justifyContent: "flex-end" }}>
                                <button onClick={() => setPuanlamaPopupAdim(null)} style={popupStyles.btnVazgec}>İptal</button>
                                <button onClick={() => setPuanlamaPopupAdim("onay")} style={popupStyles.btnPrimary}>Devam Et →</button>
                            </div>
                        </div>
                    </div>
                );
            })()}

            {/* Puanlama Onay */}
            {puanlamaPopupAdim === "onay" && (
                <div style={popupStyles.overlay}>
                    <div style={{ ...popupStyles.modal, width: "440px" }}>
                        <div style={popupStyles.baslik}>⚠️ Sayfadan Ayrılıyorsunuz</div>
                        <div style={{ background: "#422006", border: "1px solid #92400e", borderRadius: "8px", padding: "1rem", marginBottom: "1.25rem", fontSize: "13px", color: "#fde68a", lineHeight: "1.7" }}>
                            Başka bir sayfaya yönlendiriliyorsunuz. <strong>Ekrandaki tarama sonuçları kaybolacak.</strong>
                            <br /><br />Seçili <strong>{secilenler.size} sembol</strong> için <strong>Puanlama ve Tahmin</strong> taraması otomatik olarak başlatılacaktır. Emin misiniz?
                        </div>
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px", marginBottom: "1.25rem", fontSize: "12px" }}>
                            {[["Piyasa", mod], ["Para Birimi", paraBirimi], ["Vade", puanlamaVade],
                              ...(puanlamaVade === "Kaldıraçlı İşlem" ? [["İşlem Yönü", [...puanlamaYon].join(" & ")]] : []),
                              ["Min Puan", puanlamaMinPuan === 0 ? "0+ (Tümü)" : `${puanlamaMinPuan}+`], ["Sembol Sayısı", `${secilenler.size} sembol`],
                            ].map(([k, v]) => (
                                <div key={k} style={{ display: "flex", justifyContent: "space-between", background: "#0f172a", borderRadius: "6px", padding: "6px 10px" }}>
                                    <span style={{ color: "#94a3b8" }}>{k}:</span>
                                    <strong style={{ color: "#e2e8f0" }}>{v}</strong>
                                </div>
                            ))}
                        </div>
                        <div style={{ display: "flex", gap: "8px", justifyContent: "flex-end" }}>
                            <button onClick={() => setPuanlamaPopupAdim("kriter")} style={popupStyles.btnVazgec}>← Geri</button>
                            <button onClick={() => setPuanlamaPopupAdim(null)} style={popupStyles.btnVazgec}>Hayır, İptal</button>
                            <button onClick={() => {
                                const hisseListesi = [...secilenler];
                                setPuanlamaPopupAdim(null);
                                navigate("/puanlama-tahmin", { state: {
                                    kaynak: "birlesik_skor", piyasa: mod, para_birimi: paraBirimi,
                                    vade: puanlamaVade, islem_yonu: [...puanlamaYon].join(","),
                                    min_puan: puanlamaMinPuan, hisse_listesi: hisseListesi, oto_baslat: true,
                                } });
                            }} style={popupStyles.btnPrimary}>Evet, Başlat 🚀</button>
                        </div>
                    </div>
                </div>
            )}

            {/* Başlık */}
            <div style={{display:"flex",alignItems:"center",gap:14,marginBottom:24}}>
                <span style={{fontSize:32}}>🔍</span>
                <div>
                    <h1 style={{margin:0,fontSize:22,fontWeight:800,color:C.text}}>Birleşik Skor</h1>
                    <p style={{ margin: 0, fontSize: 13, color: C.muted }}>
                        ML tabanlı konfidans skoru · {(veriKaynagi?.sonuclar || []).length} sembol · {listelenenMod}
                    </p>
                </div>
            </div>

            {/* Tarama Kriterleri */}
            <div style={{
                background: C.panel, border: `1px solid ${C.border}`, borderRadius: 12,
                padding: "16px 20px", marginBottom: 20, display: "flex", gap: 12,
                flexWrap: "wrap", alignItems: "flex-end",
                opacity: calisiyor ? 0.5 : 1, pointerEvents: calisiyor ? "none" : "auto", transition: "opacity 0.3s",
            }}>
                {/* Piyasa */}
                <fieldset style={{ border: `1px solid ${C.border}`, borderRadius: 8, padding: "6px 12px 10px", margin: 0 }}>
                    <legend style={{ fontSize: 11, color: C.muted, fontWeight: 600, padding: "0 4px", letterSpacing: "0.05em" }}>PİYASA</legend>
                    <div style={{ display: "flex", gap: 6 }}>
                        {piyasaSecenekleri.map(m => (
                            <button key={m} onClick={() => setMod(m)} style={{
                                padding: "5px 14px", borderRadius: 6, fontWeight: 700, fontSize: 13, cursor: "pointer",
                                border: `2px solid ${mod === m ? C.purple : C.border}`,
                                background: mod === m ? C.purple + "22" : "transparent",
                                color: mod === m ? C.purple : C.muted,
                            }}>{m}</button>
                        ))}
                    </div>
                </fieldset>

                {/* Para Birimi */}
                <fieldset style={{ border: `1px solid ${C.border}`, borderRadius: 8, padding: "6px 12px 10px", margin: 0 }}>
                    <legend style={{ fontSize: 11, color: C.muted, fontWeight: 600, padding: "0 4px", letterSpacing: "0.05em" }}>PARA BİRİMİ</legend>
                    <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                        {paraBirimiSecenekleri.map(pb => (
                            <button key={pb} onClick={() => setParaBirimi(pb)} disabled={calisiyor} style={{
                                padding: "5px 12px", borderRadius: 6, fontWeight: 700, fontSize: 12, cursor: calisiyor ? "not-allowed" : "pointer",
                                border: `2px solid ${paraBirimi === pb ? "#a78bfa" : C.border}`,
                                background: paraBirimi === pb ? "#a78bfa22" : "transparent",
                                color: paraBirimi === pb ? "#a78bfa" : C.muted,
                            }}>{pb}</button>
                        ))}
                    </div>
                </fieldset>

                {/* Min Konfidans */}
                <fieldset style={{ border: `1px solid ${C.border}`, borderRadius: 8, padding: "6px 12px 10px", margin: 0 }}>
                    <legend style={{ fontSize: 11, color: C.muted, fontWeight: 600, padding: "0 4px", letterSpacing: "0.05em", display: "flex", alignItems: "center", gap: 4 }}>
                        MİN KONFİDANS <BilgiIkonu karti="min_konfidans" setBilgiKarti={setBilgiKarti} />
                    </legend>
                    <div style={{ display: "flex", gap: 6 }}>
                        {[0, 50, 70, 85].map(v => (
                            <button key={v} onClick={() => setMinKonfidans(v)} style={{
                                padding: "5px 12px", borderRadius: 6, fontSize: 12, cursor: "pointer",
                                border: `2px solid ${minKonfidans === v ? konfidansRenk(v || 1) : C.border}`,
                                background: minKonfidans === v ? konfidansRenk(v || 1) + "22" : "transparent",
                                color: minKonfidans === v ? konfidansRenk(v || 1) : C.muted, fontWeight: 600,
                            }}>{v === 0 ? "Hepsi" : `≥${v}`}</button>
                        ))}
                    </div>
                </fieldset>

                {/* Min Confluence */}
                <fieldset style={{ border: `1px solid ${C.border}`, borderRadius: 8, padding: "6px 12px 10px", margin: 0 }}>
                    <legend style={{ fontSize: 11, color: C.muted, fontWeight: 600, padding: "0 4px", letterSpacing: "0.05em", display: "flex", alignItems: "center", gap: 4 }}>
                        MİN CONFLUENCE <BilgiIkonu karti="min_confluence" setBilgiKarti={setBilgiKarti} />
                    </legend>
                    <div style={{ display: "flex", gap: 6 }}>
                        {[[3,"3+"],[4,"4+"],[5,"5+"]].map(([v, label]) => (
                            <button key={v} onClick={() => setMinConfluence(v)} style={{
                                padding: "5px 12px", borderRadius: 6, fontSize: 12, cursor: "pointer",
                                border: `2px solid ${minConfluence === v ? C.teal : C.border}`,
                                background: minConfluence === v ? C.teal + "22" : "transparent",
                                color: minConfluence === v ? C.teal : C.muted, fontWeight: 600,
                            }}>{label}</button>
                        ))}
                    </div>
                </fieldset>

                {/* Tara */}
                <button onClick={taramaBaslat} disabled={calisiyor} style={{
                    padding: "10px 28px", borderRadius: 8, fontWeight: 700, fontSize: 14, cursor: calisiyor ? "not-allowed" : "pointer",
                    background: calisiyor ? C.border : "linear-gradient(135deg,#4c1d95,#7c3aed)",
                    border: "none", color: "white", alignSelf: "flex-end",
                }}>
                    {calisiyor ? "⏳ Taranıyor..." : "🔍 Tara"}
                </button>
            </div>

            {calisiyor && (
                <>
                    <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10,
                        padding: "10px 16px", borderRadius: 8, background: "#422006", border: "1px solid #92400e" }}>
                        <span style={{ fontSize: 16 }}>⚠️</span>
                        <span style={{ fontSize: 13, color: "#fde68a", fontWeight: 600 }}>
                            Tarama tamamlanıncaya kadar sayfayı kapatmayın
                        </span>
                    </div>
                    {taramaDurum && <TaramaIlerlemePaneli durum={taramaDurum} mod={mod} />}
                </>
            )}

            {veriKaynagi && (
                <>
                    {/* Özet Kartlar — en solda İşlemler menüsü */}
                    <div style={{ display: "flex", gap: 12, marginBottom: 16, flexWrap: "wrap" }}>
                        <div style={{ position: "relative", display: "flex" }} ref={menuRef}>
                            <button onClick={() => setIslemMenuAcik(v => !v)} style={{
                                background: C.panel, border: `1px solid ${C.border}`, borderRadius: 10,
                                padding: "12px 18px", display: "flex", alignItems: "center", gap: 8,
                                color: C.text, cursor: "pointer", fontSize: 13, fontWeight: 600, height: "100%",
                            }}>İşlemler ▾</button>
                            {islemMenuAcik && (
                                <div style={{ position: "absolute", top: "calc(100% + 4px)", left: 0, background: C.panel,
                                    border: `1px solid ${C.border}`, borderRadius: 10, boxShadow: "0 8px 24px rgba(0,0,0,0.4)",
                                    zIndex: 100, minWidth: 260, overflow: "visible" }}>
                                    {[
                                        { label: dogrulukKaydediliyor ? "⏳ Kaydediliyor..." : "✅ Doğruluk Analizine Gönder", aktif: true, onClick: dogrulukKaydet },
                                        { label: "🔮 Geçmiş Simülasyonuna Gönder", aktif: false, onClick: gecmisSimGonder },
                                        { label: "🔀 Çoklu Taramaya Gönder",       aktif: true,  onClick: cokluTaramayaGonder },
                                        { label: "🏆 Puanlamaya Gönder",           aktif: true,  onClick: puanlamayaGonder },
                                        { label: "⏰ Alarm Ekle",                  aktif: true,  onClick: alarmAc },
                                        { label: "🔎 İzleme Listesine Ekle",       aktif: false, onClick: izlemeListesineEkle },
                                    ].map(item => (
                                        <button key={item.label} onClick={item.aktif ? item.onClick : undefined} disabled={!item.aktif}
                                            style={{ display: "block", width: "100%", textAlign: "left",
                                                padding: "10px 16px", border: "none", background: "none",
                                                fontSize: 13, borderBottom: `1px solid ${C.border}`,
                                                cursor: item.aktif ? "pointer" : "default",
                                                color: item.aktif ? C.text : C.muted }}>{item.label}</button>
                                    ))}
                                    <IndirMenusu veri={filtrelenmis} setIslemMenuAcik={setIslemMenuAcik} />
                                </div>
                            )}
                        </div>
                        {[
                            { ikon: "📊", baslik: "Toplam Sembol",    deger: veriKaynagi.toplam,                            renk: C.accent, karti: null },
                            { ikon: "⬆⬆", baslik: "Çok Yüksek",       deger: kademeGrup["Çok Yüksek"] || 0,                 renk: C.bullish, karti: null },
                            { ikon: "⬆",  baslik: "Yüksek",           deger: kademeGrup["Yüksek"] || 0,                     renk: "#22c55e", karti: null },
                            { ikon: "→",  baslik: "Orta",             deger: kademeGrup["Orta"] || 0,                       renk: C.gold, karti: null },
                            { ikon: "🏛",  baslik: "Piyasa Rejimi",    deger: veriKaynagi.rejim || "—",                     renk: C.teal, karti: "piyasa_rejim" },
                            { ikon: "🤖",  baslik: "Model CV Skoru",   deger: veriKaynagi.model_cv ? `%${(veriKaynagi.model_cv * 100).toFixed(1)}` : "—", renk: C.purple, karti: "model_cv" },
                        ].map(k => (
                            <div key={k.baslik} style={{
                                background: C.panel, border: `1px solid ${C.border}`, borderRadius: 10,
                                padding: "12px 18px", display: "flex", alignItems: "center", gap: 10, flex: 1, minWidth: 130,
                            }}>
                                <span style={{ fontSize: 20 }}>{k.ikon}</span>
                                <div>
                                    <div style={{ fontSize: 11, color: C.muted }}>
                                        {k.baslik}{k.karti && <BilgiIkonu karti={k.karti} setBilgiKarti={setBilgiKarti} />}
                                    </div>
                                    <div style={{ fontSize: 18, fontWeight: 700, color: k.renk }}>{k.deger}</div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Filtre Kartı — sonuç listesinden hemen önce */}
                    <div style={{
                        background: C.panel, border: `1px solid ${C.border}`, borderRadius: 12,
                        padding: "16px 18px", marginBottom: 14, display: "flex", flexWrap: "wrap",
                        gap: 18, alignItems: "flex-end",
                    }}>
                        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                            <span style={{ fontSize: 11, color: C.muted, fontWeight: 600, letterSpacing: "0.05em" }}>
                                KONFİDANS
                            </span>
                            <div style={{ display: "flex", gap: 6 }}>
                                {[0, 50, 70, 85].map(v => (
                                    <button key={v} onClick={() => setMinKonfidans(v)} style={{
                                        padding: "5px 12px", borderRadius: 6, fontSize: 12, cursor: "pointer",
                                        border: `1px solid ${minKonfidans === v ? konfidansRenk(v || 1) : C.border}`,
                                        background: minKonfidans === v ? konfidansRenk(v || 1) + "22" : "transparent",
                                        color: minKonfidans === v ? konfidansRenk(v || 1) : C.muted, fontWeight: 600,
                                    }}>{v === 0 ? "Hepsi" : `≥${v}`}</button>
                                ))}
                            </div>
                        </div>

                        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                            <span style={{ fontSize: 11, color: C.muted, fontWeight: 600, letterSpacing: "0.05em" }}>
                                KADEME
                            </span>
                            <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                                {[["HEPSI", "Hepsi", C.accent],
                                  ["Çok Yüksek", "⬆⬆ Çok Yüksek", C.bullish],
                                  ["Yüksek",     "⬆ Yüksek",       "#22c55e"],
                                  ["Orta",       "→ Orta",          C.gold],
                                  ["Düşük",      "⬇ Düşük",         C.muted],
                                ].map(([key, label, renk]) => (
                                    <button key={key} onClick={() => setFiltre(key)} style={{
                                        padding: "5px 14px", borderRadius: 6, fontSize: 12, cursor: "pointer", fontWeight: 600,
                                        border: `1px solid ${filtre === key ? renk : C.border}`,
                                        background: filtre === key ? renk + "22" : "transparent",
                                        color: filtre === key ? renk : C.muted,
                                    }}>{label} ({key === "HEPSI" ? veriKaynagi.toplam : kademeGrup[key] || 0})</button>
                                ))}
                            </div>
                        </div>

                        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                            <span style={{ fontSize: 11, color: C.muted, fontWeight: 600, letterSpacing: "0.05em" }}>YÖN</span>
                            <div style={{ display: "flex", gap: 6 }}>
                                {[["HEPSI", "Hepsi", C.accent], ["ALIŞ", "▲ Alış", C.bullish], ["SATIŞ", "▼ Satış", C.bearish]].map(([key, label, renk]) => (
                                    <button key={key} onClick={() => setYonFiltre(key)} style={{
                                        padding: "5px 14px", borderRadius: 6, fontSize: 12, cursor: "pointer", fontWeight: 600,
                                        border: `1px solid ${yonFiltre === key ? renk : C.border}`,
                                        background: yonFiltre === key ? renk + "22" : "transparent",
                                        color: yonFiltre === key ? renk : C.muted,
                                    }}>{label}</button>
                                ))}
                            </div>
                        </div>

                        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                            <span style={{ fontSize: 11, color: C.muted, fontWeight: 600, letterSpacing: "0.05em" }}>
                                CONFLUENCE
                            </span>
                            <div style={{ display: "flex", gap: 6 }}>
                                {[[3,"3+"],[4,"4+"],[5,"5+"]].map(([v, label]) => (
                                    <button key={v} onClick={() => setMinConfluence(v)} style={{
                                        padding: "5px 12px", borderRadius: 6, fontSize: 12, cursor: "pointer",
                                        border: `1px solid ${minConfluence === v ? C.teal : C.border}`,
                                        background: minConfluence === v ? C.teal + "22" : "transparent",
                                        color: minConfluence === v ? C.teal : C.muted, fontWeight: 600,
                                    }}>{label}</button>
                                ))}
                            </div>
                        </div>

                        <div style={{ flex: 1 }} />

                        <input
                            placeholder="Sembol ara..."
                            value={aramaMetni}
                            onChange={e => setAramaMetni(e.target.value)}
                            style={{ padding: "7px 12px", borderRadius: 6, border: `1px solid ${C.border}`,
                                background: C.bg, color: C.text, fontSize: 13, outline: "none" }}
                        />
                    </div>

                    <div style={{ background: C.panel, border: `1px solid ${C.border}`, borderRadius: 12, overflow: "hidden" }}>
                        <div style={{ padding: "10px 14px", borderBottom: `1px solid ${C.border}`, background: C.bg,
                            display: "flex", alignItems: "center", gap: 8 }}>
                            <span style={{ fontSize: 12, color: C.muted }}>
                                Gösterilen: <strong style={{ color: C.text }}>{filtrelenmis.length}</strong>
                                {filtrelenmis.length !== veriKaynagi.toplam && <span> / {veriKaynagi.toplam}</span>} sembol
                                {secilenler.size > 0 && <span style={{ color: C.accent, marginLeft: 8 }}>· {secilenler.size} seçili</span>}
                            </span>
                        </div>

                        <div style={{ overflowX: "auto" }}>
                            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
                                <thead>
                                    <tr style={{ borderBottom: `1px solid ${C.border}` }}>
                                        <th style={{ padding: "10px 8px", width: 36 }}>
                                            <input type="checkbox" checked={tumSecili} onChange={toggleTum}
                                                style={{ cursor: "pointer", width: 14, height: 14 }} />
                                        </th>
                                        {[
                                            { label: "Hisse",         karti: null },
                                            { label: paraBirimi === "USD (Futures)" ? "Fiyat (USD-F)" : paraBirimi ? `Fiyat (${paraBirimi})` : "Fiyat (USD)", karti: null },
                                            { label: "Konfidans",     karti: "konfidans" },
                                            { label: "Kademe",        karti: "kademe" },
                                            { label: "Yön",           karti: null },
                                            { label: "Aktif Modüller",karti: "aktif_moduller" },
                                            { label: "Confluence",    karti: "confluence" },
                                            { label: "Sektör RS",     karti: "sektor_rs" },
                                            { label: "Haber",         karti: "haber" },
                                        ].map(({ label, karti }) => (
                                            <th key={label} style={{ padding: "10px 8px", textAlign: "left",
                                                color: C.muted, fontSize: 11, fontWeight: 700, letterSpacing: "0.03em", whiteSpace: "nowrap" }}>
                                                {label}{karti && <BilgiIkonu karti={karti} setBilgiKarti={setBilgiKarti} />}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {filtrelenmis.map((r, i) => {
                                        const kb    = kademeBilgi(r.kademe);
                                        const kr    = konfidansRenk(r.konfidans);
                                        const secli = secilenler.has(r.symbol);
                                        const yon   = r.yon === "ALIŞ" ? C.bullish : r.yon === "SATIŞ" ? C.bearish : C.muted;
                                        return (
                                            <tr key={r.symbol + i}
                                                onClick={() => setDetaySatir(r)}
                                                style={{
                                                borderBottom: `1px solid ${C.border}`,
                                                background: secli ? C.accent + "11" : i % 2 === 0 ? "transparent" : C.bg + "88",
                                                cursor: "pointer",
                                            }}>
                                                <td style={{ padding: "10px 8px", textAlign: "center" }}
                                                    onClick={e => e.stopPropagation()}>
                                                    <input type="checkbox" checked={secli} onChange={() => toggleSec(r.symbol)}
                                                        style={{ cursor: "pointer", width: 14, height: 14 }} />
                                                </td>
                                                <td style={{ padding: "10px 8px", fontWeight: 700, color: C.accent, whiteSpace: "nowrap" }}>
                                                    {r.symbol}
                                                </td>
                                                <td style={{ padding: "10px 8px", whiteSpace: "nowrap", color: C.text }}>
                                                    {r.fiyat != null ? r.fiyat : "—"}
                                                </td>
                                                <td style={{ padding: "10px 8px", minWidth: 140 }}>
                                                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                        <SkorBar deger={r.konfidans} renk={kr} />
                                                        <span style={{ color: kr, fontWeight: 700, minWidth: 38 }}>
                                                            {r.konfidans?.toFixed(1)}
                                                        </span>
                                                    </div>
                                                </td>
                                                <td style={{ padding: "10px 8px" }}>
                                                    <span style={{
                                                        padding: "3px 10px", borderRadius: 20, fontSize: 11, fontWeight: 700,
                                                        background: kb.bg, color: kb.renk,
                                                    }}>
                                                        {kb.ikon} {r.kademe}
                                                    </span>
                                                </td>
                                                <td style={{ padding: "10px 8px" }}>
                                                    <span style={{ color: yon, fontWeight: 700, fontSize: 12 }}>
                                                        {r.yon === "ALIŞ" ? "▲ ALIŞ" : r.yon === "SATIŞ" ? "▼ SATIŞ" : "— NÖTR"}
                                                    </span>
                                                </td>
                                                <td style={{ padding: "10px 8px", maxWidth: 260 }}>
                                                    <ModulEtiketleri moduller={r.aktif_moduller} katkilar={r.modul_katkilar} />
                                                </td>
                                                <td style={{ padding: "10px 8px", textAlign: "center" }}>
                                                    <span style={{
                                                        fontSize: 13, fontWeight: 700,
                                                        color: r.min_confluence_karsilandi ? C.bullish : C.muted,
                                                    }}>
                                                        {r.aktif_modul_sayisi}
                                                        {r.min_confluence_karsilandi ? " ✓" : ""}
                                                    </span>
                                                </td>
                                                <td style={{ padding: "10px 8px", textAlign: "center" }}>
                                                    {r.sektorel_momentum != null ? (
                                                        <span style={{
                                                            color: r.sektorel_momentum > 50 ? C.bullish : C.bearish,
                                                            fontWeight: 600, fontSize: 12,
                                                        }}>
                                                            {r.sektorel_momentum.toFixed(1)}
                                                        </span>
                                                    ) : <span style={{ color: C.muted }}>—</span>}
                                                </td>
                                                <td style={{ padding: "10px 8px", textAlign: "center" }}>
                                                    {r.haber_duygu_skoru != null ? (
                                                        <div>
                                                            <span style={{
                                                                color: r.haber_duygu_skoru > 50 ? C.bullish : C.bearish,
                                                                fontWeight: 600, fontSize: 12,
                                                            }}>
                                                                {r.haber_duygu_skoru.toFixed(1)}
                                                            </span>
                                                            {r.haber_tip === "genel" && (
                                                                <span title="Sembol bazlı haber bulunamadı — genel piyasa skoru gösteriliyor"
                                                                    style={{ fontSize: 9, color: C.muted, display: "block", lineHeight: 1.2 }}>
                                                                    genel
                                                                </span>
                                                            )}
                                                        </div>
                                                    ) : <span style={{ color: C.muted }}>—</span>}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                            {filtrelenmis.length === 0 && (
                                <div style={{ padding: 48, textAlign: "center", color: C.muted }}>
                                    <div style={{ fontSize: 32, marginBottom: 8 }}>🔍</div>
                                    <div>Filtre koşulunu karşılayan sembol yok.</div>
                                </div>
                            )}
                        </div>
                    </div>
                </>
            )}

            {!veriKaynagi && !calisiyor && (
                <div style={{ textAlign: "center", padding: 60, color: C.muted }}>
                    <div style={{ fontSize: 48, marginBottom: 16 }}>🧠</div>
                    <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 8, color: C.text }}>
                        Birleşik Skor Modülü
                    </div>
                    <div style={{ fontSize: 13, maxWidth: 480, margin: "0 auto", lineHeight: 1.6 }}>
                        Tüm tarama modüllerinin sinyallerini Logistic Regression ile ağırlıklandırarak
                        her sembol için 0-100 konfidans skoru üretir. Min 3 modül confluence zorunlu.
                        Modelin kendisini (ağırlık matrisi, eğitim) yönetmek için ayrı
                        "Modül Ağırlık Merkezi" sayfasını kullan.
                    </div>
                    <button onClick={taramaBaslat} style={{
                        marginTop: 24, padding: "10px 32px", borderRadius: 10, fontSize: 15, cursor: "pointer",
                        background: "linear-gradient(135deg,#7c3aed,#3b82f6)", border: "none", color: "white", fontWeight: 700,
                    }}>Taramayı Başlat</button>
                </div>
            )}
        </div>
    );
}
